export default {
  en: {
    dashboard: 'Dashboard',
    widget: 'Widget',
    shiftRunner: 'Shift Runner',
    insights: 'Insights',
    due: 'Due',
    expired: 'Expired',
    upcoming: 'Upcoming',
    completed: 'Completed',
    learnMore: 'Learn More',
    pleaseSubscribe: 'Please Subscribe',
    // CreateDashboard
    'create-dashboard': 'Create Dashboard',
    name: 'Name',
    roles: 'Roles',
    'starting-point': 'Starting Point',
    'name-description':
      'Select a name for your dashboard. Users will see this name in the selector.',
    'roles-description':
      'Select Roles for your dashboard. Users who are assigned these roles will be able to see and choose this dashboard.',
    'starting-point-description':
      'Choose a starting point. You can choose a QSRSoft dashboard, another dashboard that you created, or a blank canvas.',
    cancel: 'Cancel',
    back: 'Back',
    next: 'Next',
    preview: 'Preview',
    'name-required': 'Name is required',
    'name-exists': 'Dashboard with that name already exists',
    'roles-required': 'Roles are required',
    'blank-canvas': 'Blank Canvas',
    'qsr-presets': 'QSR Presets',
    'your-saved-dashboards': 'Your Saved Dashboards',
    // ResetDashboard
    'reset-dashboard': 'Reset Dashboard',
    'reset-description':
      'Choose a starting point to reset the current selected dashboard to. You can choose a QSRSoft dashboard, or a blank canvas. After selecting a starting point, click the Save button to apply the changes.',
    // Settings
    'widget-settings': 'Widget Settings',
    'row-settings': 'Row Settings',
    'column-settings': 'Column Settings',
    close: 'Close',
    reset: 'Reset',
    save: 'Save',
    // DashboardContainerSettingsMulti
    customizeDashboardContainers: 'Customize Dashboard Containers',
    unableToSaveSettings: 'Unable to save dashboard settings.',
    unableToResetSettings: 'Unable to reset dashboard settings to default.',
    // no_favorites_card
    noShortcuts: 'You have no folder or file shortcuts.',
    add: 'Add',
    // Shared
    moreInfo: 'More Info',
    noData: 'No Data',
    actual: 'Actual',
    current: 'Current',
    // BudgetWidget
    budget: 'Budget',
    fiscalPeriod: 'Fiscal Period',
    vsBudget: 'Vs Budget',
    // FoodWidget
    food: 'Food',
    week: 'Week',
    // TextSettings
    bulletinBoardSettings: 'Bulletin Board Settings',
    addText: 'Add Text',
    isLink: 'is link',
    url: 'URL',
    text: 'Text',
    // BUSalesRankPopUp
    oneYearComp: '1 Year Comp',
    twoYearComp: '2 Year Comp',
    // VoiceSmiley
    voice: 'VOICE',
    surveys: 'Surveys',
    numSurveys: '# of Surveys',
    voiceInfoText:
      'Data is received 2 days after SMG and grouped by date of customer visit. SMG defaults to date of customer survey. Due to these differences, it should <strong>not</strong> be expected for the sites to match.',
    // SmileySettings
    metric: 'Metric',
    all: 'All',
    metrics: 'Metrics',
    differentThresholds: 'Selected Metrics have different threshold values.',
    orSelectFewer: 'or select fewer metrics.',
    groupedMetrics: 'These are the grouped metrics:',
    group: 'Group',
    happyUpper: 'happy upper',
    happyLower: 'happy lower',
    neutralLower: 'neutral lower',
    // RMHC / Round Up
    roundUp: 'Round Up',
    helpingHands: 'Helping Hands',
    mtdDollar: 'MTD $',
    mtdCount: 'MTD Count',
    progressGoal: 'Progress / Goal',
    pctToGoal: '% to Goal:',
    goalsHit: 'Goals hit:',
    orgSettingsChanging: 'Org Settings Changing',
    orgSettingsConfirm:
      'You are about to change Org level settings. Are you sure?',
    no: 'No',
    donationDollar: 'Donation $',
    donationCount: 'Donation Count',
    goal: 'Goal',
    numOfDonations: '# of Donations',
    donationsDollar: 'Donations $',
    donationsCountGoal: 'Donations Count Goal',
    donationsDollarGoal: 'Donations $ Goal',
    pctOfGoal: '% of Goal',
    // Voice row labels
    voiceOverall: 'Overall',
    beNice: 'Be Nice',
    beFast: 'Be Fast',
    quality: 'Quality',
    clean: 'Clean',
    accuracy: 'Accuracy',
    // VoiceContainer
    customerFeedbackAndDonations: 'Customer Feedback & Donations',
    // BigArch / Incentives
    bigArch: 'Big Arch',
    'hot-honey': 'Hot Honey',
    'snack-wraps': 'Snack Wraps',
    // Shared incentive keys
    'incentive-rank-out-of': 'Rank out of',
    'incentive-restaurants': 'Restaurants',
    'incentive-rank': 'Rank',
    'incentive-rank-compared': 'Rank of the store compared to the whole BU',
    'incentive-units-1k-gc': 'Units/1K GC',
    'incentive-units-1k-rod-gc': 'Units/1K ROD GC',
    // BigArchWidget
    'big-arch-units': 'Big Arch Units',
    'big-arch-sold-related':
      'Number of menu items that are sold related to Big Arch during Rest of Day (ROD) per thousand units.',
    'big-arch-menu-items':
      'The associated menu items are 25442, 25443, and 25444',
    // HotHoneyWidget
    'hot-honey-units': 'Hot Honey Units',
    'hot-honey-sold-related':
      'Number of menu items that are sold related to Hot Honey during Rest of Day (ROD) per thousand units.',
    // SnackWrapsWidget
    'wrap-units': 'Wrap Units',
    'snack-wraps-message':
      'Snack Wraps are now reported as individual items here',
    'snack-wraps-sold-related':
      'Number of menu items that are sold related to Wraps during Rest of Day (ROD) per thousand units.',
    // IncentiveContainer
    leaderboard: 'Leaderboard',
    'mccrispy-strips': 'McCrispy Strips',
    'round-up-pos': 'Round Up POS/Employee',
    '3d-gc-incentive': '3D Guest Count Incentive',
    'default-incentives': 'Default Incentives',
    'new-beverage': 'New Beverages',
    // BUGrid
    org: 'Org',
    orgVs: 'Org vs',
    // BusinessUnitContainer
    comp: 'Comp',
    sales: 'Sales',
    service: 'Service',
    labor: 'Labor',
    'digital-app': 'Digital App',
    'addon-subscribed': 'BU Add-on · Subscribed',
    'addon-upgrade': 'BU Add-on · Upgrade',
    'addon-upgrade-tooltip':
      'Talk to your BU lead about adding the Business Unit Subscription to get visibility to the BU Comparison views',
    'bu-no-visibility':
      'You do not have visibility to the BU Comparison view for one or more of the following reasons:',
    'bu-app-backgrounded':
      'On mobile, the app has been on in the background too long. If so, please quit and restart the app.',
    'bu-no-subscription':
      'Your Business Unit is not subscribed to BU Data & Analytics product',
    'bu-opted-out':
      'You have "opted out" in MyQSRSoft Administration for BU data share.',
    'bu-contact-leadership':
      'Please contact your BU leadership with questions about the BU subscription and associated report views.',
    // BUCompTypeSelector
    'comp-calendar': 'Calendar',
    'comp-trading': 'Trading',
    'comp-same-store': 'Same Store',
    'comp-all-store': 'All Store',
    // BUSales tooltip
    'bu-financial-info':
      'Financial is used for current mid-month or date ranges that span outside completed months. Financial excludes locations that have not been open for a full 13 months. Default for Financial is Trading Day Comparison.',
    'bu-analytic-info':
      'Analytic is used for completed months and date ranges that include completed months. Analytics uses a 5-day rule. If a location is missing sales for 5 or more days (in either Current Year or Prior Year) it is excluded from the calculation. Default for Analytic is Calendar Day Comparison.',
    'bu-financial-info-rank':
      'Financial is used for current mid-month or date ranges that span outside completed months. Financial excludes locations that have not been open for a full 13 months. Defaults to Trading Day Comparison.',
    'bu-analytic-info-rank':
      'Analytic is used for completed months and date ranges that include completed months. Analytics uses a 5-day rule. If a location is missing sales for 5 or more days (in either Current Year or Prior Year) it is excluded from the calculation. Defaults to Calendar Day Comparison.',
    // BUSales rows
    'bu-row-sales': 'Sales',
    'bu-row-gcs': "GC's",
    'bu-row-avg-sales': 'Avg Sales',
    'bu-row-avg-check': 'Average Check',
    'bu-row-avg-check-diff': 'Average Check +/-',
    'bu-row-avg-check-diff-pct': 'Average Check +/- %',
    'bu-row-bfast-gcrd': 'BFast GC/R/D',
    'bu-row-bfast-gcrd-diff': 'BFast GC/R/D +/-',
    'bu-row-bfast-pct-sales': 'BFast % of Sales',
    'bu-row-mcdelivery-avg-check': 'McDelivery Average Check',
    'bu-row-mcdelivery-gcrd': 'McDelivery GC/R/D',
    'bu-row-mcdelivery-gcrd-diff': 'McDelivery GC/R/D +/-',
    'bu-row-gma-del-avg-check': 'GMA Del Average Check',
    'bu-row-gma-del-gcrd-diff': 'GMA Del GC/R/D +/-',
    'bu-row-3po-avg-check': '3P0 Average Check',
    'bu-row-3po-gcrd-diff': '3P0 GC/R/D +/-',
    'bu-row-dt-pct-sales': 'DT % of Total Sales',
    'bu-row-dt-gcrd': 'DT GC/R/D',
    'bu-row-dt-gcrd-diff': 'DT GC/R/D +/-',
    // BUPeaksService format info tooltip
    'bu-peaks-timeslice-label': 'Timeslice',
    'bu-peaks-format-info-diff': 'Default values display the relative difference vs your BU',
    'bu-peaks-format-info-detail': 'Enable "Show BU/Org values" to display the raw values for each metric',
    // BUService rows
    'bu-row-oepe-no-park': 'OEPE W/O Park',
    'bu-row-oepe-no-park-diff': 'OEPE W/O Park +/-',
    'bu-row-oepe': 'OEPE',
    'bu-row-oepe-diff': 'OEPE +/-',
    'bu-row-r2p': 'R2P',
    'bu-row-r2p-diff': 'R2P +/-',
    'bu-row-avg-ctp': 'Avg CTP',
    'bu-row-avg-ctp-diff': 'Avg CTP +/-',
    'bu-row-kvs-items-gc': 'KVS Items / GC',
    'bu-row-kvs-items-gc-diff': 'KVS Items / GC +/-',
    'bu-row-kvs-time-gc': 'KVS Time / GC',
    'bu-row-kvs-time-gc-diff': 'KVS Time / GC +/-',
    'bu-row-dt-pulled-fwd': 'DT Pulled Fwrd %',
    'bu-row-dt-pulled-fwd-diff': 'DT Pulled Fwrd % +/-',
    'bu-row-healthy-use': 'Healthy Use',
    'bu-row-healthy-use-diff': 'Healthy Use +/-',
    // BULabor rows
    'bu-row-crew-labor': 'Crew Labor %',
    'bu-row-actual-labor': 'Actual Labor %',
    'bu-row-avg-rate': 'Avg Rate',
    'bu-row-tpph': 'TPPH',
    'bu-row-total-labor': 'Total Labor %',
    // BUFood rows
    'bu-row-base-food': 'Base Food %',
    'bu-row-comp-waste': 'Comp Waste %',
    'bu-row-condiments': 'Condiments %',
    'bu-row-discount': 'Discount %',
    'bu-row-emp-meals': 'Emp Meals %',
    'bu-row-fob': 'FOB %',
    'bu-row-raw-waste': 'Raw Waste %',
    'bu-row-stat-var': 'Stat Var %',
    'bu-row-unexplained': 'Unexplained %',
    'bu-row-pnl-food-cost': 'PNL Food Cost %',
    'bu-row-pnl-paper-cost': 'PNL Paper Cost %',
    // BUDigitalApp rows
    'bu-row-digital-sales': 'Digital Sales %',
    'bu-row-digital-gc': 'Digital GC %',
    'bu-row-digital-avg-check': 'Digital Average Check',
    'bu-row-digital-grd': 'Digital G/R/D',
    'bu-row-scanned-offer-sales': 'Scanned Offer Sales',
    'bu-row-scanned-offer-gcs': "Scanned Offer GC's",
    'bu-row-scanned-offer-avg-check': 'Scanned Offer Average Check',
    'bu-row-scanned-offer-grd': 'Scanned Offer G/R/D',
    'bu-row-gma-delivery-sales': 'GMA Delivery Sales',
    'bu-row-gma-delivery-gcs': "GMA Delivery GC's",
    'bu-row-gma-delivery-avg-check': 'GMA Delivery Average Check',
    'bu-row-gma-delivery-grd': 'GMA Delivery G/R/D',
    'bu-row-loyalty-sales': 'Loyalty Self ID Sales',
    'bu-row-loyalty-gcs': "Loyalty Self ID GC's",
    'bu-row-loyalty-avg-check': 'Loyalty Self ID Average Check',
    'bu-row-loyalty-grd': 'Loyalty Self ID G/R/D',
    'bu-row-mop-offer-sales': 'MOP W/ Offer Sales',
    'bu-row-mop-offer-gcs': "MOP W/ Offer GC's",
    'bu-row-mop-offer-avg-check': 'MOP W/ Offer Average Check',
    'bu-row-mop-offer-grd': 'MOP W/ Offer G/R/D',
    'bu-row-mop-no-offer-sales': 'MOP W/O Offer Sales',
    'bu-row-mop-no-offer-gcs': "MOP W/O Offer GC's",
    'bu-row-mop-no-offer-avg-check': 'MOP W/O Offer Average Check',
    'bu-row-mop-no-offer-grd': 'MOP W/O Offer G/R/D',
    'bu-row-mop-curb-gcs': "MOP Curb GC's %",
    'bu-row-mop-fc-gcs': "MOP FC GC's %",
    'bu-row-mop-table-gcs': "MOP Table GC's %",
    'bu-row-mop-dt-gcs': "MOP DT GC's %",
    // BUVoice rows
    'bu-row-overall': 'Overall %',
    'bu-row-friendliness': 'Friendliness %',
    'bu-row-fast': 'Fast %',
    'bu-row-quality': 'Quality %',
    'bu-row-cleanliness': 'Cleanliness %',
    'bu-row-accuracy': 'Accuracy %',
    'bu-row-dt-overall': 'DT Overall %',
    'bu-row-dt-friendliness': 'DT Friendliness %',
    'bu-row-dt-fast': 'DT Fast %',
    'bu-row-dt-quality': 'DT Quality %',
    'bu-row-dt-cleanliness': 'DT Cleanliness %',
    'bu-row-dt-accuracy': 'DT Accuracy %',
    'bu-row-fc-overall': 'FC Overall %',
    'bu-row-fc-friendliness': 'FC Friendliness %',
    'bu-row-fc-fast': 'FC Fast %',
    'bu-row-fc-quality': 'FC Quality %',
    'bu-row-fc-cleanliness': 'FC Cleanliness %',
    'bu-row-fc-accuracy': 'FC Accuracy %',
    // BUTurnover rows
    'bu-row-crew-mth-ann-turnover': 'Crew Mth Ann Turnover',
    'bu-row-crew-3mo-turnover': 'Crew Three Month Turnover',
    'bu-row-crew-term': 'Crew Term',
    'bu-row-avg-crew-hire': 'Avg Crew Hire',
    'bu-row-crew-roster': 'Crew Roster',
    'bu-row-crew-ttm-turnover': 'Crew TTM Turnover',
    'bu-row-crew-ytd-turnover': 'Crew YTD Turnover',
    'bu-row-shift-mth-ann-turnover': 'Shift Mth Ann Turnover',
    'bu-row-shift-3mo-turnover': 'Shift Three Month Turnover',
    'bu-row-shift-term': 'Shift Term',
    'bu-row-avg-shift-hire': 'Avg Shift Hire',
    'bu-row-shift-roster': 'Shift Roster',
    'bu-row-shift-ttm-turnover': 'Shift TTM Turnover',
    'bu-row-shift-ytd-turnover': 'Shift YTD Turnover',
    // BUDigitalOrderPts rows
    'bu-row-dop-digital-gc': 'Digital GC %',
    'bu-row-dop-digital-sales': 'Digital Sales %',
    'bu-row-dop-digital-grd': 'Digital G/R/D',
    'bu-row-dop-mop-gcs': "MOP GC's %",
    'bu-row-dop-mop-sales': 'MOP Sales %',
    'bu-row-dop-mop-gcrd': 'MOP GC/R/D',
    'bu-row-dop-gma-del-gc': 'GMA Del GC %',
    'bu-row-dop-gma-del-sales': 'GMA Del Sales %',
    'bu-row-dop-gma-del-grd': 'GMA Del G/R/D',
    'bu-row-dop-kiosk-gc': 'Kiosk GC %',
    'bu-row-dop-kiosk-sales': 'Kiosk Sales %',
    'bu-row-dop-kiosk-grd': 'Kiosk G/R/D',
    'bu-row-dop-delivery-gc': 'Delivery GC %',
    'bu-row-dop-delivery-sales': 'Delivery Sales %',
    'bu-row-dop-delivery-grd': 'Delivery G/R/D',
    // BUDateRange
    'start-date': 'Start Date',
    'end-date': 'End Date',
    // BUSalesRankPopUp
    'bu-sales': 'BU Sales',
    rankings: 'Rankings',
    'custom-date-range-bu': 'Custom Date Range',
    thru: 'Thru',
    // BUDigitalApp
    'fo-disclaimer':
      'FO sales results are displayed after McDonalds quarterly sales release.',
    // BUVoice
    'voice-rankings': 'Voice Rankings',
    'bu-comp-type-disclaimer':
      'This widget is only available for Business Unit and Field Office comparison types.',
    'voice-data-behind':
      'Voice data is generally 2 days behind. Please select an earlier date range',
    // BUTurnover
    people: 'People',
    'people-metrics-full-months':
      'People metrics are calculated using full months.',
    'people-multiple-months':
      'If multiple months are selected, the most recent complete month is used.',
    'people-partial-month':
      'If a past month is partially selected, the full month is used.',
    'people-detailed-breakdown':
      'For a detailed breakdown, see the BU Rank report.',
    'people-requires-full-month': 'People data requires full month date range',
    // BUDigitalOrderPts
    'digital-order-pts': 'Digital Order Pts',
    // BUAppTrends
    'bu-loyalty-trend': 'BU Loyalty 90-day Active Trend',
    'bu-loyalty-tooltip':
      'Number of unique customers who placed at least one digital app GC in the 90-day period. Because a customer can visit more than one restaurant in an organization, this number cannot be added across restaurants.',
    // Consulting
    qsrsoftConsultingServices: 'QSRSoft Consulting Services',
    consultingHelpsCapture:
      'QSRSoft Consulting helps capture cashflow opportunity',
    cashflowOpportunity: 'Cashflow Opportunity',
    total: 'Total',
    laborPotentialCF: 'Labor Potential CF',
    fobPotentialCF: 'FOB Potential CF',
    buGCGapPotentialCF: 'BU GC Gap Potential CF',
    // File Manager
    resourceLibrary: 'Resource Library',
    // Calendar
    calendar: 'Calendar',
    all_roles: 'All Roles',
    organization_calendar: 'Organization Calendar',
    shared: 'Shared',
    birthdays: 'Birthdays',
    work_anniversaries: 'Work Anniversaries',
    // ScoreCard
    scorecards: 'Scorecards',
    'please-contact-org-admin':
      'Please contact your Org admin to create a scorecard.',
    mtd: 'MTD',
    'last-month': 'Last Month',
    ytd: 'YTD',
    color: 'Color',
    'scorecard-setting': 'Scorecard Setting',
    settings: 'Settings',
    delete: 'Delete',
    'delete-scorecard': 'Delete Scorecard',
    'are-you-sure':
      'Are you sure you want to delete this scorecard? This action cannot be undone.',
    'no-data': 'No Data',
    'avg-goal': 'Avg Goal',
    diff: 'Diff',
    // TH Dashboard - Insights
    'did-you-know': 'Did you know?',
    'employee-requests': 'Employee Requests',
    waste: 'Waste',
    'closing-hours': 'Closing Hours',
    // WasteInsight template
    'waste-insight-text':
      '{dateText}, you have {count} {storeWord} that are missing at least {threshold} {dayWord} of recorded waste',
    'store-singular': 'store',
    'store-plural': 'stores',
    'day-singular': 'day',
    'day-plural': 'days',
    // ClosingHourInsight template
    'closing-hour-insight-text':
      '{dateText}, you have {lobbyCount} lobbies and {dtCount} DTs where the latest transaction is {threshold} minutes or more before the closing time',
    // TH Dashboard - Today
    today: 'Today',
    'current-day-sales': 'Current Day Sales',
    'current-day-service': 'Current Day Service',
    'current-day-updates-around': 'Current day updates around {time}',
    // TH Dashboard - Snapshot
    snapshot: 'Snapshot',
    'dayparts-sales': 'DayParts Sales',
    'dayparts-service': 'DayParts Service',
    'open-11am': 'Open - 11am',
    '11am-close': '11am - Close',
    'service-times': 'Service Times',
    // TH CurrentDaySales / SalesWidget rows
    'th-row-net-sales': 'Net Sales',
    'th-row-transactions': 'Transactions',
    'th-row-refund-transactions': 'Refund Transactions',
    'th-row-eat-in-trans': 'Eat In Trans',
    'th-row-eat-in-refund-trans': 'Eat In Refund Trans',
    'th-row-take-out-trans': 'Take Out Trans',
    'th-row-take-out-refund-trans': 'Take Out Refund Trans',
    'th-row-drive-thru-trans': 'Drive Thru Trans',
    'th-row-drive-thru-refund-trans': 'Drive Thru Refund Trans',
    'th-row-delivery-trans': 'Delivery Trans',
    'th-row-delivery-refund-trans': 'Delivery Refund Trans',
    'th-row-kiosk-trans': 'Kiosk Trans',
    'th-row-kiosk-refund-trans': 'Kiosk Refund Trans',
    'th-row-mobile-take-out-trans': 'Mobile Take Out Trans',
    'th-row-mobile-take-out-refund-trans': 'Mobile Take Out Refund Trans',
    'th-row-mobile-drive-thru-trans': 'Mobile Drive Thru Trans',
    'th-row-mobile-drive-thru-refund-trans': 'Mobile Drive Thru Refund Trans',
    'th-row-refund-sales': 'Refund Sales',
    'th-row-avg-check': 'Avg Check',
    'th-row-eat-in-net-sales': 'Eat In Net Sales',
    'th-row-eat-in-refund-sales': 'Eat In Refund Sales',
    'th-row-eat-in-avg-check': 'Eat In Avg Check',
    'th-row-take-out-net-sales': 'Take Out Net Sales',
    'th-row-take-out-refund-sales': 'Take Out Refund Sales',
    'th-row-take-out-avg-check': 'Take Out Avg Check',
    'th-row-drive-thru-net-sales': 'Drive Thru Net Sales',
    'th-row-drive-thru-refund-sales': 'Drive Thru Refund Sales',
    'th-row-drive-thru-avg-check': 'Drive Thru Avg Check',
    'th-row-delivery-net-sales': 'Delivery Net Sales',
    'th-row-delivery-refund-sales': 'Delivery Refund Sales',
    'th-row-delivery-avg-check': 'Delivery Avg Check',
    'th-row-kiosk-net-sales': 'Kiosk Net Sales',
    'th-row-kiosk-refund-sales': 'Kiosk Refund Sales',
    'th-row-kiosk-avg-check': 'Kiosk Avg Check',
    'th-row-mobile-take-out-net-sales': 'Mobile Take Out Net Sales',
    'th-row-mobile-take-out-refund-sales': 'Mobile Take Out Refund Sales',
    'th-row-mobile-take-out-avg-check': 'Mobile Take Out Avg Check',
    'th-row-mobile-delivery-net-sales': 'Mobile Delivery Net Sales',
    'th-row-mobile-delivery-refund-sales': 'Mobile Delivery Refund Sales',
    'th-row-mobile-delivery-avg-check': 'Mobile Delivery Avg Check',
    // TH Service rows
    'th-row-greet-time': 'Greet Time',
    'th-row-order-time': 'Order Time',
    'th-row-queue-time': 'Queue Time',
    'th-row-window-time': 'Window Time',
    'th-row-total-time': 'Total Time',
    // TH SalesWidget (Snapshot) rows
    'th-row-manager-void-amt': 'Manager Void Amt',
    'th-row-cash-over-short': 'Cash Over/Short',
    'th-row-canceled-item-amt': 'Canceled Item Amt',
    'th-row-canceled-item-cnt': 'Canceled Item Cnt',
    'th-row-canceled-order-amt': 'Canceled Order Amt',
    'th-row-canceled-order-cnt': 'Canceled Order Cnt',
    'th-row-manager-void-cnt': 'Manager Void Cnt',
    'th-row-overring-amt': 'Overring Amt',
    // TH Labor rows
    'th-row-hourly-labor-pct': 'Hourly Labor %',
    'th-row-hourly-labor-hours': 'Hourly Labor Hours',
    'th-row-management-labor-pct': 'Management Labor %',
    'th-row-hourly-labor-dollar': 'Hourly Labor $',
    'th-row-salaried-labor-hours': 'Salaried Labor Hours',
    'th-row-total-labor-pct': 'Total Labor %',
    'th-row-proj-labor-guide': 'Proj Labor Guide',
    'th-row-total-labor-hours': 'Total Labor Hours',
    'th-row-training-hours': 'Training Hours',
    'th-row-labor-cost': 'Labor Cost',
    'th-row-trans-per-labor-hour': 'Trans / Labor Hour',
    'th-row-act-labor-guide-hours': 'Act Labor Guide Hours',
    'th-row-adj-proj-hours': 'Adj Proj +/- Hours',
    'th-row-avg-hourly-rate': 'Avg Hourly Rate',
    // TH Shared headers
    'plus-minus': '+/-',
    // TH Main section titles
    controls: 'Controls',
    'shared-links': 'Shared Links',
    'file-manager': 'File Manager',
    'mock-role': 'Mock role',
    forms: 'Forms',
    equipment: 'Equipment',
    // Standard main section titles
    'snapshot-month': 'Snapshot Month',
    // Calendar
    'view-calendar': 'View Calendar',
    'calendar-options': 'Calendar Options',
    // TH Budget rows
    'th-row-total-labor-dollars': 'Total Labor Dollars',
    'th-row-food-cost': 'Food Cost',
    'th-row-food-cost-pct': 'Food Cost %',
    'th-row-annual-salary': 'Annual Salary',
    'th-row-crew-dollars': 'Crew Dollars',
    'th-row-crew-labor-pct': 'Crew Labor %',
    'th-row-manager-labor-pct': 'Manager Labor %',
    // TH Food rows
    'th-row-adj-theo-food-cost-pct': 'Adj Theoretical Food Cost %',
    'th-row-food-var-pct': 'Food Var %',
    'th-row-total-waste-pct': 'Total Waste %',
    'th-row-total-cost': 'Total Cost',
    'th-row-paper-cost': 'Paper Cost',
    'th-row-other-cost': 'Other Cost',
    'th-row-total-var-cost': 'Total Var Cost',
    'th-row-food-var-cost': 'Food Var Cost',
    'th-row-paper-var-cost': 'Paper Var Cost',
    'th-row-other-var-cost': 'Other Var Cost',
    'th-row-total-waste-cost': 'Total Waste Cost',
    'th-row-total-cost-pct': 'Total Cost %',
    'th-row-paper-cost-pct': 'Paper Cost %',
    'th-row-other-cost-pct': 'Other Cost %',
    'th-row-total-var-pct': 'Total Var %',
    'th-row-paper-var-pct': 'Paper Var %',
    'th-row-other-var-pct': 'Other Var %',
    'th-row-theo-food-cost-pct': 'Theoretical Food Cost %',
    'th-row-gap-variance-pct': 'Gap Variance %',
    // TH DayPart Sales rows
    'th-row-daypart-sales': 'Sales',
    'th-row-daypart-avg-chk': 'Avg Chk',
    'th-row-daypart-tcs': "TC's",
    'th-row-daypart-dt-sales': 'DT Sales',
    'th-row-daypart-dt-avg-chk': 'DT Avg Chk',
    'th-row-daypart-dt-tcs': "DT TC's",
    'th-row-daypart-lobby-sales': 'Lobby Sales',
    'th-row-daypart-lobby-avg-chk': 'Lobby Avg Chk',
    'th-row-daypart-lobby-tcs': "Lobby TC's",
    // CompTypeSelector
    'trading': 'Trading',
    // Security / Insights
    'error-loading-data': 'Error Loading Data',
    'security-events': 'Events',
    'security-locations': 'Locations',
    'security-employees': 'Employees',
    'security-drill-down': 'Security Analysis',
    'top-events': 'Top Events',
    'top-locations': 'Top Locations',
    'top-cashiers': 'Top Cashiers',
    'top-managers': 'Top Managers',
    'cashiers': 'Cashiers',
    'managers': 'Managers',
    // SecurityTable
    'transactions': 'TRANSACTIONS',
    'activity-label': 'Activity',
    'date-header': 'Date',
    'time-header': 'Time',
    'daypart-header': 'Day Part',
    'register-header': 'Register',
    'crew-header': 'Crew',
    'manager-header': 'Manager',
    'mgr-code-header': 'Manager Code Entered',
    'details-header': 'View Detail',
    'camera-header': 'Camera',
    'amount-header': 'Amount',
    'remaining-amount-header': 'Remaining Amount',
    'tender-type-header': 'Tender Type',
    'loyalty-id-header': 'Loyalty ID',
    'event-type-header': 'Type',
    'activity-type-header': 'Activity Type',
    'promo-type-header': 'Promo Type',
    'discount-type-header': 'Discount Type',
    'billable-org-header': 'Billable Organization',
    'lockout-type-header': 'Lock Out Type',
    'item-count-header': 'Item Count',
    'coupon-type-header': 'Coupon Type',
    'overring-amount-header': 'Overring Amount',
    'reduction-amount-header': 'Reduction Amount',
    'discount-amount-header': 'Discount Amount',
    'promo-amount-header': 'Promo Amount',
    'refund-amount-header': 'Refund Amount',
    'data-failed-to-load': 'The data failed to load. Please try again.',
    'boolean-true': 'True',
    'boolean-false': 'False',
    'tender-cash': 'Cash',
    'tender-cashless': 'Cashless',
    'tender-us$_cashless': 'US$ Cashless',
    'tender-gift_card': 'Gift Card',
    'tender-no_tender': 'No Tender',
    'tender-billable_sales': 'Billable Sales',
    'tender-other': 'Other',
    // Security event token labels
    'cash_refund': 'Cash Refund',
    'cashless_refund': 'Cashless Refund',
    'pos_overring': 'POS Overring',
    'other_promo': 'Other Promo',
    'total_order_promo': 'Total Promo',
    'total_promo': 'Total Promo',
    'billable_sales': 'Billable Sales',
    'drawer_open': 'Drawer Open',
    't_red_before': 'Transaction Reduction Before',
    't_red_after': 'Transaction Reduction After',
    'mobile_discount': 'Mobile Discount',
    'mobile_promo': 'Mobile Promo',
    'pos_auto_discount': 'POS Auto Discount',
    'other_discount': 'Other Discount',
    'loyalty_reward_ids': 'Loyalty Reward',
    'employee_meal': 'Employee Meal',
    'manager_meal': 'Manager Meal',
    'duplicate_card_swipe': 'Duplicate Card Swipe',
    'coupon': 'Coupon',
    'all_discount': 'All Discounts',
    'all_promo': 'All Promos',
    'high_lock_out': 'High Lock Out',
    'delivery_promo': 'Delivery Promo',
    'all_events': 'Mixed Activities',
    'event-type-earn': 'Earn',
    'event-type-burn': 'Burn',
    // SecurityTableSlideUp
    'highlight-info': 'Highlighted rows indicate the cashier was changed in C&I after the drawer was changed at the POS during drawer count.',
    // MoreInfo
    'more-info': 'More Info',
    'view-insight': 'View Insight',
    'drawer-open-verbiage': '{cashierName} had a drawer with {eventQuantity} {eventName} on {date} at {location}',
    'drawer-open-verbiage-burst': '{cashierName} had a burst of {eventQuantity} {eventName} on {date} at {location}',
    'other-verbiage': '{cashierName} had a drawer with {eventQuantity} {eventName} totaling {eventAmount} on {date} at {location}',
    'other-verbiage-burst': '{cashierName} had a burst of {eventQuantity} {eventName} totaling {eventAmount} on {date} at {location}',
    'extended-over-eight-hours-drawer-open-verbiage-for-cashier': 'Cashier {cashierName} averaged {eventQuantity} {eventName}/8 POS hrs over the last {numOfDays} days at {location}',
    'extended-over-eight-hours-other-verbiage-for-cashier': 'Cashier {cashierName} averaged {eventAmount} of {eventName}/8 POS hrs over the last {numOfDays} days at {location}',
    'extended-less-than-eight-hours-drawer-open-verbiage-for-cashier': 'Cashier {cashierName} had {eventQuantity} {eventName} in {lessEightHours} POS hrs over the last {numOfDays} days at {location} (less than 8 hrs)',
    'extended-less-than-eight-hours-other-verbiage-for-cashier': 'Cashier {cashierName} had {eventAmount} of {eventName} in {lessEightHours} POS hrs over the last {numOfDays} days at {location}',
    'extended-drawer-open-verbiage-for-manager': 'Manager {managerName} approved a total of {eventQuantity} {eventName} over the last {numOfDays} days at {location}',
    'extended-other-verbiage-for-manager': 'Manager {managerName} approved a total of {eventAmount} of {eventName} over the last {numOfDays} days at {location}',
    'data-failed-to-load-support': 'The data failed to load. Please try again or contact support if the issue persists.',
    // InsightsContainer
    'all-quiet-here': 'All quiet here',
    'product-outage': 'Product Outage',
    'business-day-close': 'Business Day Close',
    'open-late-close-early': 'Open Late/Close Early',
    'minor-exceptions': 'Minor Exceptions',
    'product-default': 'Default',
    'product-product-and-inventory': 'Prod/Inv',
    'product-people': 'People',
    'product-shift': 'Shift',
    'product-security': 'Security',
    'employee-request': 'Employee Requests',
    'suspicious-activity': 'Suspicious Activity',
    'rbd': 'RBD',
    'rbd-completed': 'RBD Completed',
    'rbd-activation': 'RBD Activation',
    'rbd-completed-threshold': 'RBD Completed Threshold',
    'threshold-hint': 'Alert when stores exceed this number of RBD completions in 30 days (1-10)',
    'potential-ot': 'Potential OT',
    'simplethink': 'SimpleThink',
    '30-day-terms': '30 Day Terms',
    '90-day-terms': '90 Day Terms',
    'people-terms': 'People Terms',
    'last-thirty-days': 'Last 30 Days',
    'trailing-365-days': 'Trailing 365 Days',
    'trailing-thirty-days': 'Trailing 30 Days',
    'yesterday': 'Yesterday',
    'last-seven-days': 'Last 7 Days',
    'modified-punches': 'Modified Punches',
    'store-alerts': 'Restaurant Alerts',
    'product-candi': 'C&I',
    'waste-entry': 'Waste Entry',
    'stat-inventory': 'Inventory Stat',
    // OLCEInsight
    'open-late-message': `<strong>{count}</strong> store may have <strong>{daysThreshold}</strong> or more late opens in the last 7 days. | <strong>{count}</strong> stores may have <strong>{daysThreshold}</strong> or more late opens in the last 7 days.`,
    'close-early-message': `<strong>{count}</strong> store may have <strong>{daysThreshold}</strong> or more early closes in the last 7 days. | <strong>{count}</strong> stores may have <strong>{daysThreshold}</strong> or more early closes in the last 7 days.`,
    // Shift Runner Scorecard
    'sms-shift-runner-scorecard': 'Shift Runner Scorecard',
    'sms-shift-scorecard': 'Shift Scorecard',
    'sms-no-data': 'No Data',
    'sms-overall': 'Overall',
    'sms-shift-prep': 'Shift Prep',
    'sms-shift-operational-metrics': 'Shift Operational Metrics - vs Goal',
    'sms-shift-runner': 'Shift Runner',
    'sms-shifts': 'Shifts',
    'sms-score': 'Score',
    'sms-pre-shift-checklist': 'Pre Shift Checklist',
    'sms-travel-path': 'Travel Path',
    'sms-oepe-w-o': 'OEPE W/O',
    'sms-r2p': 'R2P',
    'sms-kvs-time-per-gc': 'KVS Time/GC',
    'sms-kvs-healthy-usage': 'KVS Healthy Usage',
  },
  es: {
    dashboard: 'Tablero',
    widget: 'Widget',
    shiftRunner: 'Corredor de Turno',
    insights: 'Perspectivas',
    due: 'Vence',
    expired: 'Vencido',
    upcoming: 'Próximo',
    completed: 'Completado',
    learnMore: 'Aprende más',
    pleaseSubscribe: 'Por favor suscríbase',
    // CreateDashboard
    'create-dashboard': 'Crear Panel',
    name: 'Nombre',
    roles: 'Roles',
    'starting-point': 'Punto de Partida',
    'name-description':
      'Seleccione un nombre para su panel. Los usuarios verán este nombre en el selector.',
    'roles-description':
      'Seleccione roles para su panel. Los usuarios asignados a estos roles podrán ver y elegir este panel.',
    'starting-point-description':
      'Elija un punto de partida. Puede elegir un panel de QSRSoft, otro panel que haya creado, o un lienzo en blanco.',
    cancel: 'Cancelar',
    back: 'Atrás',
    next: 'Siguiente',
    preview: 'Vista Previa',
    'name-required': 'El nombre es obligatorio',
    'name-exists': 'Ya existe un panel con ese nombre',
    'roles-required': 'Los roles son obligatorios',
    'blank-canvas': 'Lienzo en Blanco',
    'qsr-presets': 'Presets de QSR',
    'your-saved-dashboards': 'Sus Paneles Guardados',
    // ResetDashboard
    'reset-dashboard': 'Restablecer Panel',
    'reset-description':
      'Elija un punto de partida para restablecer el panel seleccionado. Puede elegir un panel de QSRSoft o un lienzo en blanco. Después de seleccionar un punto de partida, haga clic en el botón Guardar para aplicar los cambios.',
    // Settings
    'widget-settings': 'Configuración de Widgets',
    'row-settings': 'Configuración de Filas',
    'column-settings': 'Configuración de Columnas',
    close: 'Cerrar',
    reset: 'Restablecer',
    save: 'Guardar',
    // DashboardContainerSettingsMulti
    customizeDashboardContainers: 'Personalizar Contenedores del Panel',
    unableToSaveSettings: 'No se pudo guardar la configuración del panel.',
    unableToResetSettings: 'No se pudo restablecer la configuración del panel.',
    // no_favorites_card
    noShortcuts: 'No tiene accesos directos de carpetas o archivos.',
    add: 'Agregar',
    // Shared
    moreInfo: 'Más Información',
    noData: 'Sin Datos',
    actual: 'Real',
    current: 'Actual',
    // BudgetWidget
    budget: 'Presupuesto',
    fiscalPeriod: 'Período Fiscal',
    vsBudget: 'Vs Presupuesto',
    // FoodWidget
    food: 'Alimentos',
    week: 'Semana',
    // TextSettings
    bulletinBoardSettings: 'Configuración del Tablón de Anuncios',
    addText: 'Agregar Texto',
    isLink: 'es enlace',
    url: 'URL',
    text: 'Texto',
    // BUSalesRankPopUp
    oneYearComp: 'Comparar 1 Año',
    twoYearComp: 'Comparar 2 Años',
    // VoiceSmiley
    voice: 'VOZ',
    surveys: 'Encuestas',
    numSurveys: '# de Encuestas',
    voiceInfoText:
      'Los datos se reciben 2 días después de SMG y se agrupan por fecha de visita del cliente. SMG usa por defecto la fecha de la encuesta del cliente. Debido a estas diferencias, <strong>no</strong> se debe esperar que los sitios coincidan.',
    // SmileySettings
    metric: 'Métrica',
    all: 'Todos',
    metrics: 'Métricas',
    differentThresholds:
      'Las métricas seleccionadas tienen valores de umbral diferentes.',
    orSelectFewer: 'o seleccione menos métricas.',
    groupedMetrics: 'Estas son las métricas agrupadas:',
    group: 'Grupo',
    happyUpper: 'feliz superior',
    happyLower: 'feliz inferior',
    neutralLower: 'neutral inferior',
    // RMHC / Round Up
    roundUp: 'Redondeo',
    helpingHands: 'Manos que Ayudan',
    mtdDollar: 'MTD $',
    mtdCount: 'MTD Cantidad',
    progressGoal: 'Progreso / Meta',
    pctToGoal: '% de Meta:',
    goalsHit: 'Metas alcanzadas:',
    orgSettingsChanging: 'Configuración de Org Cambiando',
    orgSettingsConfirm:
      'Está a punto de cambiar la configuración a nivel de Org. ¿Está seguro?',
    no: 'No',
    donationDollar: 'Donación $',
    donationCount: 'Cantidad de Donaciones',
    goal: 'Meta',
    numOfDonations: '# de Donaciones',
    donationsDollar: 'Donaciones $',
    donationsCountGoal: 'Meta de Cantidad de Donaciones',
    donationsDollarGoal: 'Meta de Donaciones $',
    pctOfGoal: '% de Meta',
    // Voice row labels
    voiceOverall: 'General',
    beNice: 'Ser Amable',
    beFast: 'Ser Rápido',
    quality: 'Calidad',
    clean: 'Limpieza',
    accuracy: 'Precisión',
    // VoiceContainer
    customerFeedbackAndDonations: 'Comentarios de Clientes y Donaciones',
    // BigArch / Incentives
    bigArch: 'Big Arch',
    'hot-honey': 'Hot Honey',
    'snack-wraps': 'Bocadillos Envueltos',
    // Shared incentive keys
    'incentive-rank-out-of': 'Clasificación sobre',
    'incentive-restaurants': 'Restaurantes',
    'incentive-rank': 'Clasificación',
    'incentive-rank-compared':
      'Clasificación de la tienda en comparación con todo el BU',
    'incentive-units-1k-gc': 'Unidades/1K GC',
    'incentive-units-1k-rod-gc': 'Unidades/1K ROD GC',
    // BigArchWidget
    'big-arch-units': 'Unidades de Big Arch',
    'big-arch-sold-related':
      'Número de artículos del menú vendidos relacionados con Big Arch durante el Resto del Día (ROD) por cada mil unidades.',
    'big-arch-menu-items':
      'Los artículos del menú asociados son 25442, 25443 y 25444',
    // HotHoneyWidget
    'hot-honey-units': 'Unidades de Hot Honey',
    'hot-honey-sold-related':
      'Número de artículos del menú vendidos relacionados con Hot Honey durante el Resto del Día (ROD) por cada mil unidades.',
    // SnackWrapsWidget
    'wrap-units': 'Unidades de Wrap',
    'snack-wraps-message':
      'Snack Wrap ahora se informan como elementos individuales aquí',
    'snack-wraps-sold-related':
      'Número de artículos del menú vendidos relacionados con Wraps durante el Resto del Día (ROD) por cada mil unidades.',
    // IncentiveContainer
    leaderboard: 'Tabla de Clasificación',
    'mccrispy-strips': 'Tiras McCrispy',
    'round-up-pos': 'Redondear POS/Empleado',
    '3d-gc-incentive': 'Incentivo de Cuenta de Invitados 3D',
    'default-incentives': 'Incentivos Predeterminados',
    'new-beverage': 'Nuevas Bebidas',
    // BUGrid
    org: 'Org',
    orgVs: 'Org vs',
    // BusinessUnitContainer
    comp: 'Comparar',
    sales: 'Ventas',
    service: 'Servicio',
    labor: 'Labor',
    'digital-app': 'Aplicación Digital',
    'addon-subscribed': 'Complemento BU · Suscrito',
    'addon-upgrade': 'Complemento BU · Actualizar',
    'addon-upgrade-tooltip':
      'Hable con el líder de su BU sobre cómo agregar la Suscripción de Business Unit para obtener visibilidad a las vistas de Comparación BU',
    'bu-no-visibility':
      'No tiene visibilidad a la vista de Comparación BU por una o más de las siguientes razones:',
    'bu-app-backgrounded':
      'En dispositivos móviles, la aplicación ha estado en segundo plano demasiado tiempo. Si es así, cierre y reinicie la aplicación.',
    'bu-no-subscription':
      'Su Unidad de Negocio no está suscrita al producto BU Data & Analytics',
    'bu-opted-out':
      'Ha "optado por no participar" en la Administración de MyQSRSoft para compartir datos de BU.',
    'bu-contact-leadership':
      'Por favor contacte a su liderazgo de BU con preguntas sobre la suscripción de BU y las vistas de reportes asociadas.',
    // BUCompTypeSelector
    'comp-calendar': 'Calendario',
    'comp-trading': 'Trading',
    'comp-same-store': 'Misma Tienda',
    'comp-all-store': 'Todas las Tiendas',
    // BUSales tooltip
    'bu-financial-info':
      'Financiero se usa para la mitad del mes actual o rangos de fechas que se extienden fuera de meses completados. Financiero excluye ubicaciones que no han estado abiertas por 13 meses completos. El valor predeterminado para Financiero es Comparación por Día de Trading.',
    'bu-analytic-info':
      'Analítico se usa para meses completados y rangos de fechas que incluyen meses completados. Analítico usa una regla de 5 días. Si a una ubicación le faltan ventas por 5 o más días (en el Año Actual o el Año Anterior) se excluye del cálculo. El valor predeterminado para Analítico es Comparación por Día de Calendario.',
    'bu-financial-info-rank':
      'Financiero se usa para la mitad del mes actual o rangos de fechas que se extienden fuera de meses completados. Financiero excluye ubicaciones que no han estado abiertas por 13 meses completos. El valor predeterminado es Comparación por Día de Trading.',
    'bu-analytic-info-rank':
      'Analítico se usa para meses completados y rangos de fechas que incluyen meses completados. Analítico usa una regla de 5 días. Si a una ubicación le faltan ventas por 5 o más días (en el Año Actual o el Año Anterior) se excluye del cálculo. El valor predeterminado es Comparación por Día de Calendario.',
    // BUSales rows
    'bu-row-sales': 'Ventas',
    'bu-row-gcs': "GC's",
    'bu-row-avg-sales': 'Ventas Prom.',
    'bu-row-avg-check': 'Cheque Promedio',
    'bu-row-avg-check-diff': 'Cheque Promedio +/-',
    'bu-row-avg-check-diff-pct': 'Cheque Promedio +/- %',
    'bu-row-bfast-gcrd': 'Desayuno GC/R/D',
    'bu-row-bfast-gcrd-diff': 'Desayuno GC/R/D +/-',
    'bu-row-bfast-pct-sales': 'Desayuno % de Ventas',
    'bu-row-mcdelivery-avg-check': 'McDelivery Cheque Promedio',
    'bu-row-mcdelivery-gcrd': 'McDelivery GC/R/D',
    'bu-row-mcdelivery-gcrd-diff': 'McDelivery GC/R/D +/-',
    'bu-row-gma-del-avg-check': 'GMA Del Cheque Promedio',
    'bu-row-gma-del-gcrd-diff': 'GMA Del GC/R/D +/-',
    'bu-row-3po-avg-check': '3P0 Cheque Promedio',
    'bu-row-3po-gcrd-diff': '3P0 GC/R/D +/-',
    'bu-row-dt-pct-sales': 'DT % de Ventas Totales',
    'bu-row-dt-gcrd': 'DT GC/R/D',
    'bu-row-dt-gcrd-diff': 'DT GC/R/D +/-',
    // BUPeaksService format info tooltip
    'bu-peaks-timeslice-label': 'Franja horaria',
    'bu-peaks-format-info-diff': 'Los valores predeterminados muestran la diferencia relativa con respecto a su BU',
    'bu-peaks-format-info-detail': 'Active "Mostrar valores BU/Org" para ver los valores originales de cada métrica',
    // BUService rows
    'bu-row-oepe-no-park': 'OEPE Sin Estac.',
    'bu-row-oepe-no-park-diff': 'OEPE Sin Estac. +/-',
    'bu-row-oepe': 'OEPE',
    'bu-row-oepe-diff': 'OEPE +/-',
    'bu-row-r2p': 'R2P',
    'bu-row-r2p-diff': 'R2P +/-',
    'bu-row-avg-ctp': 'CTP Prom.',
    'bu-row-avg-ctp-diff': 'CTP Prom. +/-',
    'bu-row-kvs-items-gc': 'KVS Artículos / GC',
    'bu-row-kvs-items-gc-diff': 'KVS Artículos / GC +/-',
    'bu-row-kvs-time-gc': 'KVS Tiempo / GC',
    'bu-row-kvs-time-gc-diff': 'KVS Tiempo / GC +/-',
    'bu-row-dt-pulled-fwd': 'DT Adelantado %',
    'bu-row-dt-pulled-fwd-diff': 'DT Adelantado % +/-',
    'bu-row-healthy-use': 'Uso Saludable',
    'bu-row-healthy-use-diff': 'Uso Saludable +/-',
    // BULabor rows
    'bu-row-crew-labor': 'Labor Equipo %',
    'bu-row-actual-labor': 'Labor Real %',
    'bu-row-avg-rate': 'Tarifa Prom.',
    'bu-row-tpph': 'TPPH',
    'bu-row-total-labor': 'Labor Total %',
    // BUFood rows
    'bu-row-base-food': 'Alimento Base %',
    'bu-row-comp-waste': 'Desperdicio Comp %',
    'bu-row-condiments': 'Condimentos %',
    'bu-row-discount': 'Descuento %',
    'bu-row-emp-meals': 'Comidas Emp. %',
    'bu-row-fob': 'FOB %',
    'bu-row-raw-waste': 'Desperdicio Crudo %',
    'bu-row-stat-var': 'Var. Estad. %',
    'bu-row-unexplained': 'Sin Explicar %',
    'bu-row-pnl-food-cost': 'PNL Costo Alimento %',
    'bu-row-pnl-paper-cost': 'PNL Costo Papel %',
    // BUDigitalApp rows
    'bu-row-digital-sales': 'Ventas Digitales %',
    'bu-row-digital-gc': 'GC Digital %',
    'bu-row-digital-avg-check': 'Cheque Prom. Digital',
    'bu-row-digital-grd': 'Digital G/R/D',
    'bu-row-scanned-offer-sales': 'Ventas Oferta Escaneada',
    'bu-row-scanned-offer-gcs': "GC's Oferta Escaneada",
    'bu-row-scanned-offer-avg-check': 'Cheque Prom. Oferta Escaneada',
    'bu-row-scanned-offer-grd': 'Oferta Escaneada G/R/D',
    'bu-row-gma-delivery-sales': 'Ventas Entrega GMA',
    'bu-row-gma-delivery-gcs': "GC's Entrega GMA",
    'bu-row-gma-delivery-avg-check': 'Cheque Prom. Entrega GMA',
    'bu-row-gma-delivery-grd': 'Entrega GMA G/R/D',
    'bu-row-loyalty-sales': 'Ventas Lealtad Self ID',
    'bu-row-loyalty-gcs': "GC's Lealtad Self ID",
    'bu-row-loyalty-avg-check': 'Cheque Prom. Lealtad Self ID',
    'bu-row-loyalty-grd': 'Lealtad Self ID G/R/D',
    'bu-row-mop-offer-sales': 'MOP C/ Oferta Ventas',
    'bu-row-mop-offer-gcs': "MOP C/ Oferta GC's",
    'bu-row-mop-offer-avg-check': 'MOP C/ Oferta Cheque Prom.',
    'bu-row-mop-offer-grd': 'MOP C/ Oferta G/R/D',
    'bu-row-mop-no-offer-sales': 'MOP S/ Oferta Ventas',
    'bu-row-mop-no-offer-gcs': "MOP S/ Oferta GC's",
    'bu-row-mop-no-offer-avg-check': 'MOP S/ Oferta Cheque Prom.',
    'bu-row-mop-no-offer-grd': 'MOP S/ Oferta G/R/D',
    'bu-row-mop-curb-gcs': "MOP Acera GC's %",
    'bu-row-mop-fc-gcs': "MOP FC GC's %",
    'bu-row-mop-table-gcs': "MOP Mesa GC's %",
    'bu-row-mop-dt-gcs': "MOP DT GC's %",
    // BUVoice rows
    'bu-row-overall': 'General %',
    'bu-row-friendliness': 'Amabilidad %',
    'bu-row-fast': 'Rapidez %',
    'bu-row-quality': 'Calidad %',
    'bu-row-cleanliness': 'Limpieza %',
    'bu-row-accuracy': 'Precisión %',
    'bu-row-dt-overall': 'DT General %',
    'bu-row-dt-friendliness': 'DT Amabilidad %',
    'bu-row-dt-fast': 'DT Rapidez %',
    'bu-row-dt-quality': 'DT Calidad %',
    'bu-row-dt-cleanliness': 'DT Limpieza %',
    'bu-row-dt-accuracy': 'DT Precisión %',
    'bu-row-fc-overall': 'FC General %',
    'bu-row-fc-friendliness': 'FC Amabilidad %',
    'bu-row-fc-fast': 'FC Rapidez %',
    'bu-row-fc-quality': 'FC Calidad %',
    'bu-row-fc-cleanliness': 'FC Limpieza %',
    'bu-row-fc-accuracy': 'FC Precisión %',
    // BUTurnover rows
    'bu-row-crew-mth-ann-turnover': 'Rotación Anual Mes Equipo',
    'bu-row-crew-3mo-turnover': 'Rotación 3 Meses Equipo',
    'bu-row-crew-term': 'Baja Equipo',
    'bu-row-avg-crew-hire': 'Contratación Prom. Equipo',
    'bu-row-crew-roster': 'Plantilla Equipo',
    'bu-row-crew-ttm-turnover': 'Rotación TTM Equipo',
    'bu-row-crew-ytd-turnover': 'Rotación YTD Equipo',
    'bu-row-shift-mth-ann-turnover': 'Rotación Anual Mes Turno',
    'bu-row-shift-3mo-turnover': 'Rotación 3 Meses Turno',
    'bu-row-shift-term': 'Baja Turno',
    'bu-row-avg-shift-hire': 'Contratación Prom. Turno',
    'bu-row-shift-roster': 'Plantilla Turno',
    'bu-row-shift-ttm-turnover': 'Rotación TTM Turno',
    'bu-row-shift-ytd-turnover': 'Rotación YTD Turno',
    // BUDigitalOrderPts rows
    'bu-row-dop-digital-gc': 'GC Digital %',
    'bu-row-dop-digital-sales': 'Ventas Digitales %',
    'bu-row-dop-digital-grd': 'Digital G/R/D',
    'bu-row-dop-mop-gcs': "MOP GC's %",
    'bu-row-dop-mop-sales': 'MOP Ventas %',
    'bu-row-dop-mop-gcrd': 'MOP GC/R/D',
    'bu-row-dop-gma-del-gc': 'GMA Del GC %',
    'bu-row-dop-gma-del-sales': 'GMA Del Ventas %',
    'bu-row-dop-gma-del-grd': 'GMA Del G/R/D',
    'bu-row-dop-kiosk-gc': 'Kiosco GC %',
    'bu-row-dop-kiosk-sales': 'Kiosco Ventas %',
    'bu-row-dop-kiosk-grd': 'Kiosco G/R/D',
    'bu-row-dop-delivery-gc': 'Entrega GC %',
    'bu-row-dop-delivery-sales': 'Entrega Ventas %',
    'bu-row-dop-delivery-grd': 'Entrega G/R/D',
    // BUDateRange
    'start-date': 'Fecha de Inicio',
    'end-date': 'Fecha de Fin',
    // BUSalesRankPopUp
    'bu-sales': 'Ventas BU',
    rankings: 'Rankings',
    'custom-date-range-bu': 'Rango de Fechas Personalizado',
    thru: 'Hasta',
    // BUDigitalApp
    'fo-disclaimer':
      'Los resultados de ventas de FO se muestran después de la publicación trimestral de ventas de McDonalds.',
    // BUVoice
    'voice-rankings': 'Clasificaciones de Voz',
    'bu-comp-type-disclaimer':
      'Este widget solo está disponible para tipos de comparación de Unidad de Negocio y Oficina de Campo.',
    'voice-data-behind':
      'Los datos de voz generalmente tienen 2 días de retraso. Por favor seleccione un rango de fechas anterior',
    // BUTurnover
    people: 'Personas',
    'people-metrics-full-months':
      'Las métricas de personas se calculan usando meses completos.',
    'people-multiple-months':
      'Si se seleccionan varios meses, se usa el mes completo más reciente.',
    'people-partial-month':
      'Si un mes pasado se selecciona parcialmente, se usa el mes completo.',
    'people-detailed-breakdown':
      'Para un desglose detallado, consulte el reporte de Ranking BU.',
    'people-requires-full-month':
      'Los datos de personas requieren un rango de fechas de mes completo',
    // BUDigitalOrderPts
    'digital-order-pts': 'Puntos de Pedido Digital',
    // BUAppTrends
    'bu-loyalty-trend': 'Tendencia Activa de 90 Días de Lealtad BU',
    'bu-loyalty-tooltip':
      'Número de clientes únicos que realizaron al menos un pedido digital en el período de 90 días. Debido a que un cliente puede visitar más de un restaurante en una organización, este número no se puede sumar entre restaurantes.',
    // Consulting
    qsrsoftConsultingServices: 'Servicios de Consultoría QSRSoft',
    consultingHelpsCapture:
      'QSRSoft Consultoría ayuda a capturar oportunidades de flujo de caja',
    cashflowOpportunity: 'Oportunidad de Flujo de Caja',
    total: 'Total',
    laborPotentialCF: 'Potencial CF Laboral',
    fobPotentialCF: 'Potencial CF FOB',
    buGCGapPotentialCF: 'Potencial CF Brecha GC BU',
    // File Manager
    resourceLibrary: 'Biblioteca de Recursos',
    // Calendar
    calendar: 'Calendario',
    all_roles: 'Todos los Roles',
    organization_calendar: 'Calendario de la Organización',
    shared: 'Compartido',
    birthdays: 'Cumpleaños',
    work_anniversaries: 'Aniversarios Laborales',
    // ScoreCard
    scorecards: 'Cuadros de Mando',
    'please-contact-org-admin':
      'Por favor, contacte a su administrador de organización para crear un cuadro de mando.',
    mtd: 'MDH',
    'last-month': 'El Mes Pasado',
    ytd: 'ADH',
    color: 'Color',
    'scorecard-setting': 'Configuración del Cuadro de Mando',
    settings: 'Configuraciones',
    delete: 'Eliminar',
    'delete-scorecard': 'Eliminar Cuadro de Mando',
    'are-you-sure':
      '¿Está seguro de que desea eliminar este cuadro de mando? Esta acción no se puede deshacer.',
    'no-data': 'Sin Datos',
    'avg-goal': 'Meta Promedio',
    diff: 'Diferencia',
    // TH Dashboard - Insights
    'did-you-know': '¿Sabías que?',
    'employee-requests': 'Solicitudes de Empleados',
    waste: 'Desperdicio',
    'closing-hours': 'Horas de Cierre',
    // WasteInsight template
    'waste-insight-text':
      '{dateText}, tienes {count} {storeWord} que faltan al menos {threshold} {dayWord} de desperdicio registrado',
    'store-singular': 'tienda',
    'store-plural': 'tiendas',
    'day-singular': 'día',
    'day-plural': 'días',
    // ClosingHourInsight template
    'closing-hour-insight-text':
      '{dateText}, tienes {lobbyCount} lobbies y {dtCount} DTs donde la última transacción fue {threshold} minutos o más antes de la hora de cierre',
    // TH Dashboard - Today
    today: 'Hoy',
    'current-day-sales': 'Ventas del Día Actual',
    'current-day-service': 'Servicio del Día Actual',
    'current-day-updates-around':
      'Actualización del día actual alrededor de las {time}',
    // TH Dashboard - Snapshot
    snapshot: 'Resumen',
    'dayparts-sales': 'Ventas por Período',
    'dayparts-service': 'Servicio por Período',
    'open-11am': 'Apertura - 11am',
    '11am-close': '11am - Cierre',
    'service-times': 'Tiempos de Servicio',
    // TH CurrentDaySales / SalesWidget rows
    'th-row-net-sales': 'Ventas Netas',
    'th-row-transactions': 'Transacciones',
    'th-row-refund-transactions': 'Transacciones de Reembolso',
    'th-row-eat-in-trans': 'Trans. Comer Aquí',
    'th-row-eat-in-refund-trans': 'Trans. Reembolso Comer Aquí',
    'th-row-take-out-trans': 'Trans. Para Llevar',
    'th-row-take-out-refund-trans': 'Trans. Reembolso Para Llevar',
    'th-row-drive-thru-trans': 'Trans. Autoservicio',
    'th-row-drive-thru-refund-trans': 'Trans. Reembolso Autoservicio',
    'th-row-delivery-trans': 'Trans. Entrega',
    'th-row-delivery-refund-trans': 'Trans. Reembolso Entrega',
    'th-row-kiosk-trans': 'Trans. Kiosco',
    'th-row-kiosk-refund-trans': 'Trans. Reembolso Kiosco',
    'th-row-mobile-take-out-trans': 'Trans. Móvil Para Llevar',
    'th-row-mobile-take-out-refund-trans': 'Trans. Reembolso Móvil Para Llevar',
    'th-row-mobile-drive-thru-trans': 'Trans. Móvil Autoservicio',
    'th-row-mobile-drive-thru-refund-trans':
      'Trans. Reembolso Móvil Autoservicio',
    'th-row-refund-sales': 'Ventas de Reembolso',
    'th-row-avg-check': 'Cheque Promedio',
    'th-row-eat-in-net-sales': 'Ventas Netas Comer Aquí',
    'th-row-eat-in-refund-sales': 'Ventas Reembolso Comer Aquí',
    'th-row-eat-in-avg-check': 'Cheque Prom. Comer Aquí',
    'th-row-take-out-net-sales': 'Ventas Netas Para Llevar',
    'th-row-take-out-refund-sales': 'Ventas Reembolso Para Llevar',
    'th-row-take-out-avg-check': 'Cheque Prom. Para Llevar',
    'th-row-drive-thru-net-sales': 'Ventas Netas Autoservicio',
    'th-row-drive-thru-refund-sales': 'Ventas Reembolso Autoservicio',
    'th-row-drive-thru-avg-check': 'Cheque Prom. Autoservicio',
    'th-row-delivery-net-sales': 'Ventas Netas Entrega',
    'th-row-delivery-refund-sales': 'Ventas Reembolso Entrega',
    'th-row-delivery-avg-check': 'Cheque Prom. Entrega',
    'th-row-kiosk-net-sales': 'Ventas Netas Kiosco',
    'th-row-kiosk-refund-sales': 'Ventas Reembolso Kiosco',
    'th-row-kiosk-avg-check': 'Cheque Prom. Kiosco',
    'th-row-mobile-take-out-net-sales': 'Ventas Netas Móvil Para Llevar',
    'th-row-mobile-take-out-refund-sales': 'Ventas Reembolso Móvil Para Llevar',
    'th-row-mobile-take-out-avg-check': 'Cheque Prom. Móvil Para Llevar',
    'th-row-mobile-delivery-net-sales': 'Ventas Netas Entrega Móvil',
    'th-row-mobile-delivery-refund-sales': 'Ventas Reembolso Entrega Móvil',
    'th-row-mobile-delivery-avg-check': 'Cheque Prom. Entrega Móvil',
    // TH Service rows
    'th-row-greet-time': 'Tiempo de Saludo',
    'th-row-order-time': 'Tiempo de Pedido',
    'th-row-queue-time': 'Tiempo de Espera',
    'th-row-window-time': 'Tiempo de Ventanilla',
    'th-row-total-time': 'Tiempo Total',
    // TH SalesWidget (Snapshot) rows
    'th-row-manager-void-amt': 'Monto Anulación Gerente',
    'th-row-cash-over-short': 'Sobrante/Faltante de Caja',
    'th-row-canceled-item-amt': 'Monto Artículo Cancelado',
    'th-row-canceled-item-cnt': 'Cantidad Artículos Cancelados',
    'th-row-canceled-order-amt': 'Monto Orden Cancelada',
    'th-row-canceled-order-cnt': 'Cantidad Órdenes Canceladas',
    'th-row-manager-void-cnt': 'Cantidad Anulaciones Gerente',
    'th-row-overring-amt': 'Monto Sobreregistro',
    // TH Labor rows
    'th-row-hourly-labor-pct': 'Labor por Hora %',
    'th-row-hourly-labor-hours': 'Horas Labor por Hora',
    'th-row-management-labor-pct': 'Labor Gerencial %',
    'th-row-hourly-labor-dollar': 'Labor por Hora $',
    'th-row-salaried-labor-hours': 'Horas Labor Asalariado',
    'th-row-total-labor-pct': 'Labor Total %',
    'th-row-proj-labor-guide': 'Guía Labor Proyectada',
    'th-row-total-labor-hours': 'Horas Labor Total',
    'th-row-training-hours': 'Horas de Capacitación',
    'th-row-labor-cost': 'Costo de Labor',
    'th-row-trans-per-labor-hour': 'Trans / Hora Labor',
    'th-row-act-labor-guide-hours': 'Horas Guía Labor Real',
    'th-row-adj-proj-hours': 'Horas Proy. Ajust. +/-',
    'th-row-avg-hourly-rate': 'Tarifa Promedio por Hora',
    // TH Shared headers
    'plus-minus': '+/-',
    // TH Main section titles
    controls: 'Controles',
    'shared-links': 'Enlaces Compartidos',
    'file-manager': 'Administrador de Archivos',
    'mock-role': 'Simular rol',
    forms: 'Formularios',
    equipment: 'Equipo',
    // Standard main section titles
    'snapshot-month': 'Resumen Mensual',
    // Calendar
    'view-calendar': 'Ver Calendario',
    'calendar-options': 'Opciones de Calendario',
    // TH Budget rows
    'th-row-total-labor-dollars': 'Dólares Labor Total',
    'th-row-food-cost': 'Costo de Alimentos',
    'th-row-food-cost-pct': 'Costo Alimentos %',
    'th-row-annual-salary': 'Salario Anual',
    'th-row-crew-dollars': 'Dólares Equipo',
    'th-row-crew-labor-pct': 'Labor Equipo %',
    'th-row-manager-labor-pct': 'Labor Gerente %',
    // TH Food rows
    'th-row-adj-theo-food-cost-pct': 'Costo Alimento Teórico Ajust. %',
    'th-row-food-var-pct': 'Varianza Alimentos %',
    'th-row-total-waste-pct': 'Desperdicio Total %',
    'th-row-total-cost': 'Costo Total',
    'th-row-paper-cost': 'Costo de Papel',
    'th-row-other-cost': 'Otros Costos',
    'th-row-total-var-cost': 'Costo Varianza Total',
    'th-row-food-var-cost': 'Costo Varianza Alimentos',
    'th-row-paper-var-cost': 'Costo Varianza Papel',
    'th-row-other-var-cost': 'Costo Varianza Otros',
    'th-row-total-waste-cost': 'Costo Desperdicio Total',
    'th-row-total-cost-pct': 'Costo Total %',
    'th-row-paper-cost-pct': 'Costo Papel %',
    'th-row-other-cost-pct': 'Otros Costos %',
    'th-row-total-var-pct': 'Varianza Total %',
    'th-row-paper-var-pct': 'Varianza Papel %',
    'th-row-other-var-pct': 'Varianza Otros %',
    'th-row-theo-food-cost-pct': 'Costo Alimento Teórico %',
    'th-row-gap-variance-pct': 'Varianza de Brecha %',
    // TH DayPart Sales rows
    'th-row-daypart-sales': 'Ventas',
    'th-row-daypart-avg-chk': 'Cheque Prom.',
    'th-row-daypart-tcs': "TC's",
    'th-row-daypart-dt-sales': 'Ventas Autoservicio',
    'th-row-daypart-dt-avg-chk': 'Cheque Prom. Autoservicio',
    'th-row-daypart-dt-tcs': "TC's Autoservicio",
    'th-row-daypart-lobby-sales': 'Ventas Lobby',
    'th-row-daypart-lobby-avg-chk': 'Cheque Prom. Lobby',
    'th-row-daypart-lobby-tcs': "TC's Lobby",
    // CompTypeSelector
    'trading': 'Trading',
    // Security / Insights
    'error-loading-data': 'Error al Cargar Datos',
    'security-events': 'Eventos',
    'security-locations': 'Ubicaciones',
    'security-employees': 'Empleados',
    'security-drill-down': 'Análisis de Seguridad',
    'top-events': 'Principales Eventos',
    'top-locations': 'Principales Ubicaciones',
    'top-cashiers': 'Principales Cajeros',
    'top-managers': 'Principales Gerentes',
    'cashiers': 'Cajeros',
    'managers': 'Gerentes',
    // SecurityTable
    'transactions': 'TRANSACCIONES',
    'activity-label': 'Actividad',
    'date-header': 'Fecha',
    'time-header': 'Hora',
    'daypart-header': 'Parte del Día',
    'register-header': 'Caja',
    'crew-header': 'Empleado',
    'manager-header': 'Gerente',
    'mgr-code-header': 'Código de Gerente Ingresado',
    'details-header': 'Ver Detalle',
    'camera-header': 'Cámara',
    'amount-header': 'Cantidad',
    'remaining-amount-header': 'Cantidad Restante',
    'tender-type-header': 'Tipo de Pago',
    'loyalty-id-header': 'ID de Lealtad',
    'event-type-header': 'Tipo',
    'activity-type-header': 'Tipo de Actividad',
    'promo-type-header': 'Tipo de Promoción',
    'discount-type-header': 'Tipo de Descuento',
    'billable-org-header': 'Organización Facturable',
    'lockout-type-header': 'Tipo de Bloqueo',
    'item-count-header': 'Recuento de Artículos',
    'coupon-type-header': 'Tipo de Cupón',
    'overring-amount-header': 'Cantidad de Sobreprecio',
    'reduction-amount-header': 'Cantidad de Reducción',
    'discount-amount-header': 'Cantidad de Descuento',
    'promo-amount-header': 'Cantidad de Promoción',
    'refund-amount-header': 'Cantidad de Reembolso',
    'data-failed-to-load': 'Los datos no se cargaron. Por favor, inténtelo de nuevo.',
    'boolean-true': 'Sí',
    'boolean-false': 'No',
    'tender-cash': 'Efectivo',
    'tender-cashless': 'Del Tarjeta Crédito',
    'tender-us$_cashless': 'US$ Del Tarjeta Crédito',
    'tender-gift_card': 'Tarjeta de Regalo',
    'tender-no_tender': 'Sin Pago',
    'tender-billable_sales': 'Ventas Facturables',
    'tender-other': 'Otro',
    // Security event token labels
    'cash_refund': 'Reembolso en Efectivo',
    'cashless_refund': 'Reembolso del Tarjeta Credito',
    'pos_overring': 'Anulación POS',
    'other_promo': 'Otro Promo',
    'total_order_promo': 'Promo Total',
    'total_promo': 'Promo Total',
    'billable_sales': 'Ventas Facturables',
    'drawer_open': 'Cajón Abierto',
    't_red_before': 'Reducción de Transacción Antes',
    't_red_after': 'Reducción de Transacción Después',
    'mobile_discount': 'Descuento Móvil',
    'mobile_promo': 'Promo Móvil',
    'pos_auto_discount': 'Descuento Automático POS',
    'other_discount': 'Otro Descuento',
    'loyalty_reward_ids': 'Recompensa de Lealtad',
    'employee_meal': 'Comida de Empleado',
    'manager_meal': 'Comida de Gerente',
    'duplicate_card_swipe': 'Tarjeta Duplicada',
    'coupon': 'Cupón',
    'all_discount': 'Todos los Descuentos',
    'all_promo': 'Todos los Promos',
    'high_lock_out': 'Bloqueo Alto',
    'delivery_promo': 'Promo de Entrega',
    'all_events': 'Actividades Mixtas',
    'event-type-earn': 'Ganar',
    'event-type-burn': 'Canjear',
    // SecurityTableSlideUp
    'highlight-info': 'Las filas resaltadas indican que el cajero fue cambiado en C&I después de que la caja fue cambiada en el POS durante el conteo de la caja.',
    // MoreInfo
    'more-info': 'Más información',
    'view-insight': 'Ver Perspectiva',
    'drawer-open-verbiage': '{cashierName} tuvo un cajón con {eventQuantity} {eventName} el {date} en {location}',
    'drawer-open-verbiage-burst': '{cashierName} tuvo un burst de {eventQuantity} {eventName} el {date} en {location}',
    'other-verbiage': '{cashierName} tuvo un cajón con {eventQuantity} {eventName} que suman {eventAmount} el {date} en {location}',
    'other-verbiage-burst': '{cashierName} tuvo un burst de {eventQuantity} {eventName} que suman {eventAmount} el {date} en {location}',
    'extended-over-eight-hours-drawer-open-verbiage-for-cashier': 'El cajero {cashierName} promedió {eventQuantity} {eventName}/8 horas POS durante los últimos {numOfDays} días en {location}',
    'extended-over-eight-hours-other-verbiage-for-cashier': 'El cajero {cashierName} promedió {eventAmount} de {eventName}/8 horas POS durante los últimos {numOfDays} días en {location}',
    'extended-less-than-eight-hours-drawer-open-verbiage-for-cashier': 'El cajero {cashierName} tuvo {eventQuantity} {eventName} en {lessEightHours} horas POS durante los últimos {numOfDays} días en {location} (menos de 8 hrs)',
    'extended-less-than-eight-hours-other-verbiage-for-cashier': 'El cajero {cashierName} tuvo {eventAmount} de {eventName} en {lessEightHours} horas POS durante los últimos {numOfDays} días en {location}',
    'extended-drawer-open-verbiage-for-manager': 'El gerente {managerName} aprobó un total de {eventQuantity} {eventName} durante los últimos {numOfDays} días en {location}',
    'extended-other-verbiage-for-manager': 'El gerente {managerName} aprobó un total de {eventAmount} de {eventName} durante los últimos {numOfDays} días en {location}',
    'data-failed-to-load-support': 'Los datos no se cargaron. Por favor, inténtelo de nuevo o contacte a soporte si el problema persiste.',
    // InsightsContainer
    'all-quiet-here': 'Todo tranquilo aquí',
    'product-outage': 'Interrupción del Producto',
    'business-day-close': 'Cierre del Día Hábil',
    'open-late-close-early': 'Abrir Tarde/Cerrar Temprano',
    'minor-exceptions': 'Excepciones Menores',
    'product-default': 'Predeterminado',
    'product-product-and-inventory': 'Producto/Inventario',
    'product-people': 'Personas',
    'product-shift': 'Turno',
    'product-security': 'Seguridad',
    'employee-request': 'Solicitudes de Empleados',
    'suspicious-activity': 'Actividad Sospechosa',
    'rbd': 'RBD',
    'rbd-completed': 'RBD Completado',
    'rbd-activation': 'Activación RBD',
    'rbd-completed-threshold': 'Umbral RBD Completado',
    'threshold-hint': 'Alerta cuando las tiendas exceden este número de RBD completados en 30 días (1-10)',
    'potential-ot': 'OT Potencial',
    'simplethink': 'SimpleThink',
    '30-day-terms': 'Términos de 30 Días',
    '90-day-terms': 'Términos de 90 Días',
    'people-terms': 'Bajas de Personal',
    'last-thirty-days': 'Últimos 30 Días',
    'trailing-365-days': '365 Días Anteriores',
    'trailing-thirty-days': '30 Días Anteriores',
    'yesterday': 'Ayer',
    'last-seven-days': 'Últimos 7 Días',
    'modified-punches': 'Marcadas Modificadas',
    'store-alerts': 'Alertas de Restaurante',
    'product-candi': 'C&I',
    'waste-entry': 'Entrada de Desperdicio',
    'stat-inventory': 'Estadística de Inventario',
    // OLCEInsight
    'open-late-message': `<strong>{count}</strong> tienda puede tener <strong>{daysThreshold}</strong> o más aperturas tardías en los últimos 7 días. | <strong>{count}</strong> tiendas pueden tener <strong>{daysThreshold}</strong> o más aperturas tardías en los últimos 7 días.`,
    'close-early-message': `<strong>{count}</strong> tienda puede tener <strong>{daysThreshold}</strong> o más cierres anticipados en los últimos 7 días. | <strong>{count}</strong> tiendas pueden tener <strong>{daysThreshold}</strong> o más cierres anticipados en los últimos 7 días.`,
    // Shift Runner Scorecard
    'sms-shift-runner-scorecard': 'Tarjeta de Puntuación del Corredor de Turno',
    'sms-shift-scorecard': 'Tarjeta de Puntuación del Turno',
    'sms-no-data': 'Sin Datos',
    'sms-overall': 'En General',
    'sms-shift-prep': 'Preparación del Turno',
    'sms-shift-operational-metrics': 'Métricas operativas del turno - vs Objetivo',
    'sms-shift-runner': 'Corredor de Turno',
    'sms-shifts': 'Turnos',
    'sms-score': 'Puntuación',
    'sms-pre-shift-checklist': 'Lista de Verificación Previa al Turno',
    'sms-travel-path': 'Ruta de Viaje',
    'sms-oepe-w-o': 'OEPE Sin Estacionamiento',
    'sms-r2p': 'R2P',
    'sms-kvs-time-per-gc': 'Tiempo KVS por GC',
    'sms-kvs-healthy-usage': 'Uso Saludable KVS',
  },
  fr: {
    dashboard: 'Tableau de bord',
    widget: 'Widget',
    shiftRunner: 'Shift Runner',
    insights: 'Analyses',
    due: 'À échéance',
    expired: 'Expiré',
    upcoming: 'À venir',
    completed: 'Terminé',
    learnMore: 'En savoir plus',
    pleaseSubscribe: 'Veuillez souscrire',
    // CreateDashboard
    'create-dashboard': 'Créer un tableau de bord',
    name: 'Nom',
    roles: 'Rôles',
    'starting-point': 'Point de départ',
    'name-description':
      'Choisissez un nom pour votre tableau de bord. Les utilisateurs verront ce nom dans le sélecteur.',
    'roles-description':
      'Sélectionnez les rôles pour votre tableau de bord. Les utilisateurs auxquels ces rôles sont attribués pourront le voir et le choisir.',
    'starting-point-description':
      'Choisissez un point de départ. Vous pouvez partir d’un tableau de bord QSRSoft, d’un autre tableau de bord que vous avez créé, ou d’une page vierge.',
    cancel: 'Annuler',
    back: 'Retour',
    next: 'Suivant',
    preview: 'Aperçu',
    'name-required': 'Le nom est obligatoire',
    'name-exists': 'Un tableau de bord portant ce nom existe déjà',
    'roles-required': 'Les rôles sont obligatoires',
    'blank-canvas': 'Page vierge',
    'qsr-presets': 'Préréglages QSR',
    'your-saved-dashboards': 'Vos tableaux de bord enregistrés',
    // ResetDashboard
    'reset-dashboard': 'Réinitialiser le tableau de bord',
    'reset-description':
      'Choisissez le point de départ vers lequel réinitialiser le tableau de bord sélectionné. Vous pouvez choisir un tableau de bord QSRSoft ou une page vierge. Après avoir choisi un point de départ, cliquez sur Enregistrer pour appliquer les modifications.',
    // Settings
    'widget-settings': 'Paramètres du widget',
    'row-settings': 'Paramètres des lignes',
    'column-settings': 'Paramètres des colonnes',
    close: 'Fermer',
    reset: 'Réinitialiser',
    save: 'Enregistrer',
    // DashboardContainerSettingsMulti
    customizeDashboardContainers: 'Personnaliser les conteneurs du tableau de bord',
    unableToSaveSettings: 'Impossible d’enregistrer les paramètres du tableau de bord.',
    unableToResetSettings: 'Impossible de réinitialiser les paramètres du tableau de bord.',
    // no_favorites_card
    noShortcuts: 'Vous n’avez aucun raccourci de dossier ou de fichier.',
    add: 'Ajouter',
    // Shared
    moreInfo: 'Plus d’informations',
    noData: 'Aucune donnée',
    actual: 'Réel',
    current: 'En cours',
    // BudgetWidget
    budget: 'Budget',
    fiscalPeriod: 'Période fiscale',
    vsBudget: 'Vs budget',
    // FoodWidget
    food: 'Matières',
    week: 'Semaine',
    // TextSettings
    bulletinBoardSettings: 'Paramètres du tableau d’affichage',
    addText: 'Ajouter du texte',
    isLink: 'est un lien',
    url: 'URL',
    text: 'Texte',
    // BUSalesRankPopUp
    oneYearComp: 'Comparaison 1 an',
    twoYearComp: 'Comparaison 2 ans',
    // VoiceSmiley
    voice: 'VOICE',
    surveys: 'Enquêtes',
    numSurveys: 'Nb d’enquêtes',
    voiceInfoText:
      'Les données sont reçues 2 jours après SMG et regroupées par date de visite du client. SMG se base par défaut sur la date de l’enquête. En raison de ces différences, il ne faut <strong>pas</strong> s’attendre à ce que les deux sources concordent.',
    // SmileySettings
    metric: 'Indicateur',
    all: 'Tous',
    metrics: 'Indicateurs',
    differentThresholds: 'Les indicateurs sélectionnés ont des seuils différents.',
    orSelectFewer: 'ou sélectionnez moins d’indicateurs.',
    groupedMetrics: 'Voici les indicateurs regroupés :',
    group: 'Groupe',
    happyUpper: 'satisfait - borne haute',
    happyLower: 'satisfait - borne basse',
    neutralLower: 'neutre - borne basse',
    // RMHC / Round Up
    roundUp: 'Arrondi solidaire',
    helpingHands: 'Helping Hands',
    mtdDollar: 'CMJ $',
    mtdCount: 'Nombre CMJ',
    progressGoal: 'Avancement / objectif',
    pctToGoal: '% de l’objectif atteint :',
    goalsHit: 'Objectifs atteints :',
    orgSettingsChanging: 'Modification des paramètres de l’organisation',
    orgSettingsConfirm:
      'Vous êtes sur le point de modifier des paramètres au niveau de l’organisation. Confirmez-vous ?',
    no: 'Non',
    donationDollar: 'Don $',
    donationCount: 'Nombre de dons',
    goal: 'Objectif',
    numOfDonations: 'Nb de dons',
    donationsDollar: 'Dons $',
    donationsCountGoal: 'Objectif de nombre de dons',
    donationsDollarGoal: 'Objectif de dons $',
    pctOfGoal: '% de l’objectif',
    // Voice row labels
    voiceOverall: 'Global',
    beNice: 'Amabilité',
    beFast: 'Rapidité',
    quality: 'Qualité',
    clean: 'Propreté',
    accuracy: 'Exactitude',
    // VoiceContainer
    customerFeedbackAndDonations: 'Retours clients et dons',
    // BigArch / Incentives
    bigArch: 'Big Arch',
    'hot-honey': 'Hot Honey',
    'snack-wraps': 'Snack Wraps',
    // Shared incentive keys
    'incentive-rank-out-of': 'Classement sur',
    'incentive-restaurants': 'Restaurants',
    'incentive-rank': 'Classement',
    'incentive-rank-compared': 'Classement du restaurant par rapport à l’ensemble de la BU',
    'incentive-units-1k-gc': 'Unités/1 000 GC',
    'incentive-units-1k-rod-gc': 'Unités/1 000 GC ROD',
    // BigArchWidget
    'big-arch-units': 'Unités Big Arch',
    'big-arch-sold-related':
      'Nombre d’articles du menu liés à Big Arch vendus sur le reste de la journée (ROD) pour mille unités.',
    'big-arch-menu-items':
      'Les articles du menu concernés sont les 25442, 25443 et 25444',
    // HotHoneyWidget
    'hot-honey-units': 'Unités Hot Honey',
    'hot-honey-sold-related':
      'Nombre d’articles du menu liés à Hot Honey vendus sur le reste de la journée (ROD) pour mille unités.',
    // SnackWrapsWidget
    'wrap-units': 'Unités Wrap',
    'snack-wraps-message':
      'Les Snack Wraps sont désormais comptabilisés ici comme des articles individuels',
    'snack-wraps-sold-related':
      'Nombre d’articles du menu liés aux Wraps vendus sur le reste de la journée (ROD) pour mille unités.',
    // IncentiveContainer
    leaderboard: 'Classement',
    'mccrispy-strips': 'McCrispy Strips',
    'round-up-pos': 'Arrondi solidaire caisse/employé',
    '3d-gc-incentive': 'Challenge nombre de clients 3D',
    'default-incentives': 'Challenges par défaut',
    'new-beverage': 'Nouvelles boissons',
    // BUGrid
    org: 'Organisation',
    orgVs: 'Organisation vs',
    // BusinessUnitContainer
    comp: 'Comparaison',
    sales: 'Ventes',
    service: 'Service',
    labor: 'Main-d’œuvre',
    'digital-app': 'Application mobile',
    'addon-subscribed': 'Module complémentaire BU · Abonné',
    'addon-upgrade': 'Module complémentaire BU · Mise à niveau',
    'addon-upgrade-tooltip':
      'Parlez à votre responsable BU de l’ajout de l’Abonnement de l’Unité d’Affaires pour obtenir une visibilité sur les vues de Comparaison BU',
    'bu-no-visibility':
      'Vous n’avez pas accès à la vue Comparaison BU pour une ou plusieurs des raisons suivantes :',
    'bu-app-backgrounded':
      'Sur mobile, l’application est restée trop longtemps en arrière-plan. Si c’est le cas, veuillez quitter et redémarrer l’application.',
    'bu-no-subscription':
      'Votre business unit n’est pas abonnée au produit BU Data & Analytics',
    'bu-opted-out':
      'Vous avez « refusé » le partage des données BU dans l’administration MyQSRSoft.',
    'bu-contact-leadership':
      'Veuillez contacter la direction de votre BU pour toute question sur l’abonnement BU et les vues de rapports associées.',
    // BUCompTypeSelector
    'comp-calendar': 'Calendrier',
    'comp-trading': 'Exercice commercial',
    'comp-same-store': 'Restaurants comparables',
    'comp-all-store': 'Tous les restaurants',
    // BUSales tooltip
    'bu-financial-info':
      'Le mode Financier s’applique au mois en cours ou aux plages de dates dépassant les mois clôturés. Il exclut les sites ouverts depuis moins de 13 mois complets. Par défaut, le mode Financier utilise la comparaison par jour d’exploitation.',
    'bu-analytic-info':
      'Le mode Analytique s’applique aux mois clôturés et aux plages de dates incluant des mois clôturés. Il applique une règle de 5 jours : si un site n’a pas de ventes pendant 5 jours ou plus (sur l’année en cours ou l’année précédente), il est exclu du calcul. Par défaut, le mode Analytique utilise la comparaison par jour calendaire.',
    'bu-financial-info-rank':
      'Le mode Financier s’applique au mois en cours ou aux plages de dates dépassant les mois clôturés. Il exclut les sites ouverts depuis moins de 13 mois complets. Par défaut, comparaison par jour d’exploitation.',
    'bu-analytic-info-rank':
      'Le mode Analytique s’applique aux mois clôturés et aux plages de dates incluant des mois clôturés. Il applique une règle de 5 jours : si un site n’a pas de ventes pendant 5 jours ou plus (sur l’année en cours ou l’année précédente), il est exclu du calcul. Par défaut, comparaison par jour calendaire.',
    // BUSales rows
    'bu-row-sales': 'Ventes',
    'bu-row-gcs': 'GC',
    'bu-row-avg-sales': 'Ventes moyennes',
    'bu-row-avg-check': 'Ticket moyen',
    'bu-row-avg-check-diff': 'Ticket moyen +/-',
    'bu-row-avg-check-diff-pct': 'Ticket moyen +/- %',
    'bu-row-bfast-gcrd': 'GC/R/J petit-déjeuner',
    'bu-row-bfast-gcrd-diff': 'GC/R/J petit-déjeuner +/-',
    'bu-row-bfast-pct-sales': '% des ventes petit-déjeuner',
    'bu-row-mcdelivery-avg-check': 'Ticket moyen McDelivery',
    'bu-row-mcdelivery-gcrd': 'GC/R/J McDelivery',
    'bu-row-mcdelivery-gcrd-diff': 'GC/R/J McDelivery +/-',
    'bu-row-gma-del-avg-check': 'Ticket moyen livraison GMA',
    'bu-row-gma-del-gcrd-diff': 'GC/R/J livraison GMA +/-',
    'bu-row-3po-avg-check': 'Ticket moyen 3PO',
    'bu-row-3po-gcrd-diff': 'GC/R/J 3PO +/-',
    'bu-row-dt-pct-sales': '% des ventes totales au Drive',
    'bu-row-dt-gcrd': 'GC/R/J Drive',
    'bu-row-dt-gcrd-diff': 'GC/R/J Drive +/-',
    // BUPeaksService format info tooltip
    'bu-peaks-timeslice-label': 'Créneau horaire',
    'bu-peaks-format-info-diff': "Les valeurs par défaut affichent l'écart relatif par rapport à votre BU",
    'bu-peaks-format-info-detail': 'Activez « Afficher les valeurs BU/Org » pour afficher les valeurs brutes de chaque indicateur',
    // BUService rows
    'bu-row-oepe-no-park': 'OEPE hors mise en attente',
    'bu-row-oepe-no-park-diff': 'OEPE hors mise en attente +/-',
    'bu-row-oepe': 'OEPE',
    'bu-row-oepe-diff': 'OEPE +/-',
    'bu-row-r2p': 'R2P',
    'bu-row-r2p-diff': 'R2P +/-',
    'bu-row-avg-ctp': 'CTP moyen',
    'bu-row-avg-ctp-diff': 'CTP moyen +/-',
    'bu-row-kvs-items-gc': 'Articles KVS / GC',
    'bu-row-kvs-items-gc-diff': 'Articles KVS / GC +/-',
    'bu-row-kvs-time-gc': 'Temps KVS / GC',
    'bu-row-kvs-time-gc-diff': 'Temps KVS / GC +/-',
    'bu-row-dt-pulled-fwd': '% avancés au Drive',
    'bu-row-dt-pulled-fwd-diff': '% avancés au Drive +/-',
    'bu-row-healthy-use': 'Utilisation saine',
    'bu-row-healthy-use-diff': 'Utilisation saine +/-',
    // BULabor rows
    'bu-row-crew-labor': '% MO équipiers',
    'bu-row-actual-labor': '% MO réelle',
    'bu-row-avg-rate': 'Taux moyen',
    'bu-row-tpph': 'TPPH',
    'bu-row-total-labor': '% MO totale',
    // BUFood rows
    'bu-row-base-food': '% matières de base',
    'bu-row-comp-waste': '% pertes produits finis',
    'bu-row-condiments': '% condiments',
    'bu-row-discount': '% remises',
    'bu-row-emp-meals': '% repas employés',
    'bu-row-fob': '% FOB',
    'bu-row-raw-waste': '% pertes brutes',
    'bu-row-stat-var': '% écart statistique',
    'bu-row-unexplained': '% inexpliqué',
    'bu-row-pnl-food-cost': '% coût matières compte de résultat',
    'bu-row-pnl-paper-cost': '% coût papier compte de résultat',
    // BUDigitalApp rows
    'bu-row-digital-sales': '% ventes digitales',
    'bu-row-digital-gc': '% GC digital',
    'bu-row-digital-avg-check': 'Ticket moyen digital',
    'bu-row-digital-grd': 'G/R/J digital',
    'bu-row-scanned-offer-sales': 'Ventes offres scannées',
    'bu-row-scanned-offer-gcs': 'GC offres scannées',
    'bu-row-scanned-offer-avg-check': 'Ticket moyen offres scannées',
    'bu-row-scanned-offer-grd': 'G/R/J offres scannées',
    'bu-row-gma-delivery-sales': 'Ventes livraison GMA',
    'bu-row-gma-delivery-gcs': 'GC livraison GMA',
    'bu-row-gma-delivery-avg-check': 'Ticket moyen livraison GMA',
    'bu-row-gma-delivery-grd': 'G/R/J livraison GMA',
    'bu-row-loyalty-sales': 'Ventes auto-identification fidélité',
    'bu-row-loyalty-gcs': 'GC auto-identification fidélité',
    'bu-row-loyalty-avg-check': 'Ticket moyen auto-identification fidélité',
    'bu-row-loyalty-grd': 'G/R/J auto-identification fidélité',
    'bu-row-mop-offer-sales': 'Ventes MOP avec offre',
    'bu-row-mop-offer-gcs': 'GC MOP avec offre',
    'bu-row-mop-offer-avg-check': 'Ticket moyen MOP avec offre',
    'bu-row-mop-offer-grd': 'G/R/J MOP avec offre',
    'bu-row-mop-no-offer-sales': 'Ventes MOP sans offre',
    'bu-row-mop-no-offer-gcs': 'GC MOP sans offre',
    'bu-row-mop-no-offer-avg-check': 'Ticket moyen MOP sans offre',
    'bu-row-mop-no-offer-grd': 'G/R/J MOP sans offre',
    'bu-row-mop-curb-gcs': '% GC MOP retrait en voiture',
    'bu-row-mop-fc-gcs': '% GC MOP comptoir',
    'bu-row-mop-table-gcs': '% GC MOP à table',
    'bu-row-mop-dt-gcs': '% GC MOP Drive',
    // BUVoice rows
    'bu-row-overall': '% global',
    'bu-row-friendliness': '% amabilité',
    'bu-row-fast': '% rapidité',
    'bu-row-quality': '% qualité',
    'bu-row-cleanliness': '% propreté',
    'bu-row-accuracy': '% exactitude',
    'bu-row-dt-overall': '% global Drive',
    'bu-row-dt-friendliness': '% amabilité Drive',
    'bu-row-dt-fast': '% rapidité Drive',
    'bu-row-dt-quality': '% qualité Drive',
    'bu-row-dt-cleanliness': '% propreté Drive',
    'bu-row-dt-accuracy': '% exactitude Drive',
    'bu-row-fc-overall': '% global comptoir',
    'bu-row-fc-friendliness': '% amabilité comptoir',
    'bu-row-fc-fast': '% rapidité comptoir',
    'bu-row-fc-quality': '% qualité comptoir',
    'bu-row-fc-cleanliness': '% propreté comptoir',
    'bu-row-fc-accuracy': '% exactitude comptoir',
    // BUTurnover rows
    'bu-row-crew-mth-ann-turnover': 'Rotation mens. ann. équipiers',
    'bu-row-crew-3mo-turnover': 'Rotation équipiers sur 3 mois',
    'bu-row-crew-term': 'Départs équipiers',
    'bu-row-avg-crew-hire': 'Embauches moy. équipiers',
    'bu-row-crew-roster': 'Effectif équipiers',
    'bu-row-crew-ttm-turnover': 'Rotation TTM équipiers',
    'bu-row-crew-ytd-turnover': 'Rotation cumulée annuelle équipiers',
    'bu-row-shift-mth-ann-turnover': 'Rotation mens. ann. responsables de poste',
    'bu-row-shift-3mo-turnover': 'Rotation responsables de poste sur 3 mois',
    'bu-row-shift-term': 'Départs responsables de poste',
    'bu-row-avg-shift-hire': 'Embauches moy. responsables de poste',
    'bu-row-shift-roster': 'Effectif responsables de poste',
    'bu-row-shift-ttm-turnover': 'Rotation TTM responsables de poste',
    'bu-row-shift-ytd-turnover': 'Rotation cumulée annuelle responsables de poste',
    // BUDigitalOrderPts rows
    'bu-row-dop-digital-gc': '% GC digital',
    'bu-row-dop-digital-sales': '% ventes digitales',
    'bu-row-dop-digital-grd': 'G/R/J digital',
    'bu-row-dop-mop-gcs': '% GC MOP',
    'bu-row-dop-mop-sales': '% ventes MOP',
    'bu-row-dop-mop-gcrd': 'GC/R/J MOP',
    'bu-row-dop-gma-del-gc': '% GC livraison GMA',
    'bu-row-dop-gma-del-sales': '% ventes livraison GMA',
    'bu-row-dop-gma-del-grd': 'G/R/J livraison GMA',
    'bu-row-dop-kiosk-gc': '% GC borne',
    'bu-row-dop-kiosk-sales': '% ventes borne',
    'bu-row-dop-kiosk-grd': 'G/R/J borne',
    'bu-row-dop-delivery-gc': '% GC livraison',
    'bu-row-dop-delivery-sales': '% ventes livraison',
    'bu-row-dop-delivery-grd': 'G/R/J livraison',
    // BUDateRange
    'start-date': 'Date de début',
    'end-date': 'Date de fin',
    // BUSalesRankPopUp
    'bu-sales': 'Ventes BU',
    rankings: 'Classements',
    'custom-date-range-bu': 'Plage de dates personnalisée',
    thru: 'Au',
    // BUDigitalApp
    'fo-disclaimer':
      'Les résultats de ventes FO sont affichés après la publication trimestrielle des ventes McDonald’s.',
    // BUVoice
    'voice-rankings': 'Classements Voice',
    'bu-comp-type-disclaimer':
      'Ce widget n’est disponible que pour les types de comparaison Business Unit et Field Office.',
    'voice-data-behind':
      'Les données Voice accusent généralement 2 jours de retard. Veuillez sélectionner une plage de dates antérieure',
    // BUTurnover
    people: 'Ressources humaines',
    'people-metrics-full-months':
      'Les indicateurs RH sont calculés sur des mois complets.',
    'people-multiple-months':
      'Si plusieurs mois sont sélectionnés, le mois complet le plus récent est utilisé.',
    'people-partial-month':
      'Si un mois passé est partiellement sélectionné, le mois complet est utilisé.',
    'people-detailed-breakdown':
      'Pour un détail complet, consultez le rapport BU Rank.',
    'people-requires-full-month': 'Les données RH exigent une plage de dates couvrant un mois complet',
    // BUDigitalOrderPts
    'digital-order-pts': 'Points de commande digitaux',
    // BUAppTrends
    'bu-loyalty-trend': 'Tendance des actifs fidélité BU sur 90 jours',
    'bu-loyalty-tooltip':
      'Nombre de clients uniques ayant enregistré au moins un GC via l’application mobile sur la période de 90 jours. Un client pouvant fréquenter plusieurs restaurants d’une même organisation, ce nombre ne peut pas être additionné entre restaurants.',
    // Consulting
    qsrsoftConsultingServices: 'Services de conseil QSRSoft',
    consultingHelpsCapture:
      'Le conseil QSRSoft aide à capter des opportunités de trésorerie',
    cashflowOpportunity: 'Opportunité de trésorerie',
    total: 'Total',
    laborPotentialCF: 'Trésorerie potentielle MO',
    fobPotentialCF: 'Trésorerie potentielle FOB',
    buGCGapPotentialCF: 'Trésorerie potentielle écart GC BU',
    // File Manager
    resourceLibrary: 'Bibliothèque de ressources',
    // Calendar
    calendar: 'Calendrier',
    all_roles: 'Tous les rôles',
    organization_calendar: 'Calendrier de l’organisation',
    shared: 'Partagé',
    birthdays: 'Anniversaires',
    work_anniversaries: 'Anniversaires d’ancienneté',
    // ScoreCard
    scorecards: 'Tableaux de résultats',
    'please-contact-org-admin':
      'Veuillez contacter l’administrateur de votre organisation pour créer un tableau de résultats.',
    mtd: 'CMJ',
    'last-month': 'Mois dernier',
    ytd: 'CAJ',
    color: 'Couleur',
    'scorecard-setting': 'Paramètres du tableau de résultats',
    settings: 'Paramètres',
    delete: 'Supprimer',
    'delete-scorecard': 'Supprimer le tableau de résultats',
    'are-you-sure':
      'Voulez-vous vraiment supprimer ce tableau de résultats ? Cette action est irréversible.',
    'no-data': 'Aucune donnée',
    'avg-goal': 'Objectif moyen',
    diff: 'Écart',
    // TH Dashboard - Insights
    'did-you-know': 'Le saviez-vous ?',
    'employee-requests': 'Demandes des employés',
    waste: 'Pertes',
    'closing-hours': 'Heures de fermeture',
    // WasteInsight template
    'waste-insight-text':
      '{dateText}, vous avez {count} {storeWord} pour lesquels il manque au moins {threshold} {dayWord} de pertes enregistrées',
    'store-singular': 'restaurant',
    'store-plural': 'restaurants',
    'day-singular': 'jour',
    'day-plural': 'jours',
    // ClosingHourInsight template
    'closing-hour-insight-text':
      '{dateText}, vous avez {lobbyCount} salles et {dtCount} Drive où la dernière transaction précède l’heure de fermeture de {threshold} minutes ou plus',
    // TH Dashboard - Today
    today: 'Aujourd’hui',
    'current-day-sales': 'Ventes du jour',
    'current-day-service': 'Service du jour',
    'current-day-updates-around': 'Les données du jour sont actualisées vers {time}',
    // TH Dashboard - Snapshot
    snapshot: 'Instantané',
    'dayparts-sales': 'Ventes par période de la journée',
    'dayparts-service': 'Service par période de la journée',
    'open-11am': 'Ouverture - 11 h',
    '11am-close': '11 h - fermeture',
    'service-times': 'Temps de service',
    // TH CurrentDaySales / SalesWidget rows
    'th-row-net-sales': 'Ventes nettes',
    'th-row-transactions': 'Transactions',
    'th-row-refund-transactions': 'Transactions remboursées',
    'th-row-eat-in-trans': 'Trans sur place',
    'th-row-eat-in-refund-trans': 'Trans remboursées sur place',
    'th-row-take-out-trans': 'Trans à emporter',
    'th-row-take-out-refund-trans': 'Trans remboursées à emporter',
    'th-row-drive-thru-trans': 'Trans Drive',
    'th-row-drive-thru-refund-trans': 'Trans remboursées Drive',
    'th-row-delivery-trans': 'Trans livraison',
    'th-row-delivery-refund-trans': 'Trans remboursées livraison',
    'th-row-kiosk-trans': 'Trans borne',
    'th-row-kiosk-refund-trans': 'Trans remboursées borne',
    'th-row-mobile-take-out-trans': 'Trans à emporter mobile',
    'th-row-mobile-take-out-refund-trans': 'Trans remboursées à emporter mobile',
    'th-row-mobile-drive-thru-trans': 'Trans Drive mobile',
    'th-row-mobile-drive-thru-refund-trans': 'Trans remboursées Drive mobile',
    'th-row-refund-sales': 'Ventes remboursées',
    'th-row-avg-check': 'Ticket moyen',
    'th-row-eat-in-net-sales': 'Ventes nettes sur place',
    'th-row-eat-in-refund-sales': 'Ventes remboursées sur place',
    'th-row-eat-in-avg-check': 'Ticket moyen sur place',
    'th-row-take-out-net-sales': 'Ventes nettes à emporter',
    'th-row-take-out-refund-sales': 'Ventes remboursées à emporter',
    'th-row-take-out-avg-check': 'Ticket moyen à emporter',
    'th-row-drive-thru-net-sales': 'Ventes nettes Drive',
    'th-row-drive-thru-refund-sales': 'Ventes remboursées Drive',
    'th-row-drive-thru-avg-check': 'Ticket moyen Drive',
    'th-row-delivery-net-sales': 'Ventes nettes livraison',
    'th-row-delivery-refund-sales': 'Ventes remboursées livraison',
    'th-row-delivery-avg-check': 'Ticket moyen livraison',
    'th-row-kiosk-net-sales': 'Ventes nettes borne',
    'th-row-kiosk-refund-sales': 'Ventes remboursées borne',
    'th-row-kiosk-avg-check': 'Ticket moyen borne',
    'th-row-mobile-take-out-net-sales': 'Ventes nettes à emporter mobile',
    'th-row-mobile-take-out-refund-sales': 'Ventes remboursées à emporter mobile',
    'th-row-mobile-take-out-avg-check': 'Ticket moyen à emporter mobile',
    'th-row-mobile-delivery-net-sales': 'Ventes nettes livraison mobile',
    'th-row-mobile-delivery-refund-sales': 'Ventes remboursées livraison mobile',
    'th-row-mobile-delivery-avg-check': 'Ticket moyen livraison mobile',
    // TH Service rows
    'th-row-greet-time': 'Temps d’accueil',
    'th-row-order-time': 'Temps de commande',
    'th-row-queue-time': 'Temps d’attente en file',
    'th-row-window-time': 'Temps au guichet',
    'th-row-total-time': 'Temps total',
    // TH SalesWidget (Snapshot) rows
    'th-row-manager-void-amt': 'Mnt annulations manager',
    'th-row-cash-over-short': 'Excédent/manquant de caisse',
    'th-row-canceled-item-amt': 'Mnt articles annulés',
    'th-row-canceled-item-cnt': 'Nb articles annulés',
    'th-row-canceled-order-amt': 'Mnt commandes annulées',
    'th-row-canceled-order-cnt': 'Nb commandes annulées',
    'th-row-manager-void-cnt': 'Nb annulations manager',
    'th-row-overring-amt': 'Mnt surenregistrements',
    // TH Labor rows
    'th-row-hourly-labor-pct': '% MO horaire',
    'th-row-hourly-labor-hours': 'Heures MO horaire',
    'th-row-management-labor-pct': '% MO encadrement',
    'th-row-hourly-labor-dollar': 'MO horaire $',
    'th-row-salaried-labor-hours': 'Heures MO salariée',
    'th-row-total-labor-pct': '% MO totale',
    'th-row-proj-labor-guide': 'Guide MO prévu',
    'th-row-total-labor-hours': 'Heures MO totales',
    'th-row-training-hours': 'Heures de formation',
    'th-row-labor-cost': 'Coût de la main-d’œuvre',
    'th-row-trans-per-labor-hour': 'Trans / heure MO',
    'th-row-act-labor-guide-hours': 'Heures guides MO réelles',
    'th-row-adj-proj-hours': 'Heures proj ajust +/-',
    'th-row-avg-hourly-rate': 'Taux horaire moyen',
    // TH Shared headers
    'plus-minus': '+/-',
    // TH Main section titles
    controls: 'Contrôles',
    'shared-links': 'Liens partagés',
    'file-manager': 'Gestionnaire de fichiers',
    'mock-role': 'Rôle simulé',
    forms: 'Formulaires',
    equipment: 'Équipements',
    // Standard main section titles
    'snapshot-month': 'Instantané du mois',
    // Calendar
    'view-calendar': 'Voir le calendrier',
    'calendar-options': 'Options du calendrier',
    // TH Budget rows
    'th-row-total-labor-dollars': 'Total MO en dollars',
    'th-row-food-cost': 'Coût matières',
    'th-row-food-cost-pct': '% coût matières',
    'th-row-annual-salary': 'Salaire annuel',
    'th-row-crew-dollars': 'Équipiers en dollars',
    'th-row-crew-labor-pct': '% MO équipiers',
    'th-row-manager-labor-pct': '% MO managers',
    // TH Food rows
    'th-row-adj-theo-food-cost-pct': '% coût matières théorique ajusté',
    'th-row-food-var-pct': '% écart matières',
    'th-row-total-waste-pct': '% pertes totales',
    'th-row-total-cost': 'Coût total',
    'th-row-paper-cost': 'Coût papier',
    'th-row-other-cost': 'Coût autres',
    'th-row-total-var-cost': 'Coût écart total',
    'th-row-food-var-cost': 'Coût écart matières',
    'th-row-paper-var-cost': 'Coût écart papier',
    'th-row-other-var-cost': 'Coût écart autres',
    'th-row-total-waste-cost': 'Coût pertes totales',
    'th-row-total-cost-pct': '% coût total',
    'th-row-paper-cost-pct': '% coût papier',
    'th-row-other-cost-pct': '% coût autres',
    'th-row-total-var-pct': '% écart total',
    'th-row-paper-var-pct': '% écart papier',
    'th-row-other-var-pct': '% écart autres',
    'th-row-theo-food-cost-pct': '% coût matières théorique',
    'th-row-gap-variance-pct': '% écart d’intervalle',
    // TH DayPart Sales rows
    'th-row-daypart-sales': 'Ventes',
    'th-row-daypart-avg-chk': 'Ticket moy.',
    'th-row-daypart-tcs': 'TC',
    'th-row-daypart-dt-sales': 'Ventes Drive',
    'th-row-daypart-dt-avg-chk': 'Ticket moy. Drive',
    'th-row-daypart-dt-tcs': 'TC Drive',
    'th-row-daypart-lobby-sales': 'Ventes salle',
    'th-row-daypart-lobby-avg-chk': 'Ticket moy. salle',
    'th-row-daypart-lobby-tcs': 'TC salle',
    // CompTypeSelector
    'trading': 'Exercice commercial',
    // Security / Insights
    'error-loading-data': 'Erreur de chargement des données',
    'security-events': 'Événements',
    'security-locations': 'Sites',
    'security-employees': 'Employés',
    'security-drill-down': 'Analyse sécurité',
    'top-events': 'Principaux événements',
    'top-locations': 'Principaux sites',
    'top-cashiers': 'Principaux caissiers',
    'top-managers': 'Principaux managers',
    'cashiers': 'Caissiers',
    'managers': 'Managers',
    // SecurityTable
    'transactions': 'TRANSACTIONS',
    'activity-label': 'Activité',
    'date-header': 'Date',
    'time-header': 'Heure',
    'daypart-header': 'Période de la journée',
    'register-header': 'Caisse',
    'crew-header': 'Équipier',
    'manager-header': 'Manager',
    'mgr-code-header': 'Code manager saisi',
    'details-header': 'Voir le détail',
    'camera-header': 'Caméra',
    'amount-header': 'Montant',
    'remaining-amount-header': 'Montant restant',
    'tender-type-header': 'Mode de paiement',
    'loyalty-id-header': 'ID fidélité',
    'event-type-header': 'Type',
    'activity-type-header': 'Type d’activité',
    'promo-type-header': 'Type de promo',
    'discount-type-header': 'Type de remise',
    'billable-org-header': 'Organisation facturable',
    'lockout-type-header': 'Type de verrouillage',
    'item-count-header': 'Nombre d’articles',
    'coupon-type-header': 'Type de coupon',
    'overring-amount-header': 'Montant du surenregistrement',
    'reduction-amount-header': 'Montant de la réduction',
    'discount-amount-header': 'Montant de la remise',
    'promo-amount-header': 'Montant de la promo',
    'refund-amount-header': 'Montant du remboursement',
    'data-failed-to-load': 'Le chargement des données a échoué. Veuillez réessayer.',
    'boolean-true': 'Vrai',
    'boolean-false': 'Faux',
    'tender-cash': 'Espèces',
    'tender-cashless': 'Sans espèces',
    'tender-us$_cashless': 'Sans espèces USD',
    'tender-gift_card': 'Carte cadeau',
    'tender-no_tender': 'Aucun paiement',
    'tender-billable_sales': 'Ventes facturables',
    'tender-other': 'Autre',
    // Security event token labels
    'cash_refund': 'Remboursement espèces',
    'cashless_refund': 'Remboursement sans espèces',
    'pos_overring': 'Surenregistrement caisse',
    'other_promo': 'Autre promo',
    'total_order_promo': 'Promo totale',
    'total_promo': 'Promo totale',
    'billable_sales': 'Ventes facturables',
    'drawer_open': 'Ouverture de tiroir',
    't_red_before': 'Réduction de transaction avant',
    't_red_after': 'Réduction de transaction après',
    'mobile_discount': 'Remise mobile',
    'mobile_promo': 'Promo mobile',
    'pos_auto_discount': 'Remise automatique caisse',
    'other_discount': 'Autre remise',
    'loyalty_reward_ids': 'Récompense fidélité',
    'employee_meal': 'Repas employé',
    'manager_meal': 'Repas manager',
    'duplicate_card_swipe': 'Passage de carte en double',
    'coupon': 'Coupon',
    'all_discount': 'Toutes les remises',
    'all_promo': 'Toutes les promos',
    'high_lock_out': 'Verrouillage élevé',
    'delivery_promo': 'Promo livraison',
    'all_events': 'Activités mixtes',
    'event-type-earn': 'Cumul',
    'event-type-burn': 'Utilisation',
    // SecurityTableSlideUp
    'highlight-info': 'Les lignes surlignées indiquent que le caissier a été modifié dans C&I après le changement de tiroir en caisse lors du comptage.',
    // MoreInfo
    'more-info': 'Plus d’informations',
    'view-insight': 'Voir l’analyse',
    'drawer-open-verbiage': '{cashierName} a eu un tiroir avec {eventQuantity} {eventName} le {date} à {location}',
    'drawer-open-verbiage-burst': '{cashierName} a eu une série de {eventQuantity} {eventName} le {date} à {location}',
    'other-verbiage': '{cashierName} a eu un tiroir avec {eventQuantity} {eventName} pour un total de {eventAmount} le {date} à {location}',
    'other-verbiage-burst': '{cashierName} a eu une série de {eventQuantity} {eventName} pour un total de {eventAmount} le {date} à {location}',
    'extended-over-eight-hours-drawer-open-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré en moyenne {eventQuantity} {eventName}/8 h de caisse sur les {numOfDays} derniers jours à {location}',
    'extended-over-eight-hours-other-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré en moyenne {eventAmount} de {eventName}/8 h de caisse sur les {numOfDays} derniers jours à {location}',
    'extended-less-than-eight-hours-drawer-open-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré {eventQuantity} {eventName} en {lessEightHours} h de caisse sur les {numOfDays} derniers jours à {location} (moins de 8 h)',
    'extended-less-than-eight-hours-other-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré {eventAmount} de {eventName} en {lessEightHours} h de caisse sur les {numOfDays} derniers jours à {location}',
    'extended-drawer-open-verbiage-for-manager': 'Le manager {managerName} a approuvé au total {eventQuantity} {eventName} sur les {numOfDays} derniers jours à {location}',
    'extended-other-verbiage-for-manager': 'Le manager {managerName} a approuvé au total {eventAmount} de {eventName} sur les {numOfDays} derniers jours à {location}',
    'data-failed-to-load-support': 'Le chargement des données a échoué. Veuillez réessayer ou contacter le support si le problème persiste.',
    // InsightsContainer
    'all-quiet-here': 'Rien à signaler',
    'product-outage': 'Rupture de produit',
    'business-day-close': 'Clôture de la journée d’activité',
    'open-late-close-early': 'Ouverture tardive / fermeture anticipée',
    'minor-exceptions': 'Exceptions mineurs',
    'product-default': 'Par défaut',
    'product-product-and-inventory': 'Prod/stock',
    'product-people': 'RH',
    'product-shift': 'Poste',
    'product-security': 'Sécurité',
    'employee-request': 'Demandes des employés',
    'suspicious-activity': 'Activité suspecte',
    'rbd': 'RBD',
    'rbd-completed': 'RBD finalisés',
    'rbd-activation': 'Activation RBD',
    'rbd-completed-threshold': 'Seuil de RBD finalisés',
    'threshold-hint': 'Alerter lorsque des restaurants dépassent ce nombre de RBD finalisés sur 30 jours (1-10)',
    'potential-ot': 'Heures sup. potentielles',
    'simplethink': 'SimpleThink',
    '30-day-terms': 'Départs à 30 jours',
    '90-day-terms': 'Départs à 90 jours',
    'people-terms': 'Départs RH',
    'last-thirty-days': '30 derniers jours',
    'trailing-365-days': '365 derniers jours',
    'trailing-thirty-days': '30 derniers jours glissants',
    'yesterday': 'Hier',
    'last-seven-days': '7 derniers jours',
    'modified-punches': 'Pointages modifiés',
    'store-alerts': 'Alertes restaurant',
    'product-candi': 'C&I',
    'waste-entry': 'Saisie des pertes',
    'stat-inventory': 'Statistiques de stock',
    // OLCEInsight
    'open-late-message': `<strong>{count}</strong> restaurant peut avoir enregistré <strong>{daysThreshold}</strong> ouvertures tardives ou plus au cours des 7 derniers jours. | <strong>{count}</strong> restaurants peuvent avoir enregistré <strong>{daysThreshold}</strong> ouvertures tardives ou plus au cours des 7 derniers jours.`,
    'close-early-message': `<strong>{count}</strong> restaurant peut avoir enregistré <strong>{daysThreshold}</strong> fermetures anticipées ou plus au cours des 7 derniers jours. | <strong>{count}</strong> restaurants peuvent avoir enregistré <strong>{daysThreshold}</strong> fermetures anticipées ou plus au cours des 7 derniers jours.`,
    // Shift Runner Scorecard
    'sms-shift-runner-scorecard': 'Fiche de résultats du chef de quart',
    'sms-shift-scorecard': 'Fiche de résultats du quart',
    'sms-no-data': 'Aucune donnée',
    'sms-overall': 'Global',
    'sms-shift-prep': 'Préparation du quart',
    'sms-shift-operational-metrics': 'Métriques d’exploitation du quart - vs objectif',
    'sms-shift-runner': 'Chef de quart',
    'sms-shifts': 'Quarts',
    'sms-score': 'Score',
    'sms-pre-shift-checklist': 'Liste de vérification avant quart',
    'sms-travel-path': 'Parcours',
    'sms-oepe-w-o': 'OEPE sans stationnement',
    'sms-r2p': 'R2P',
    'sms-kvs-time-per-gc': 'Temps KVS par client',
    'sms-kvs-healthy-usage': 'Utilisation saine du KVS',
  },
  'fr-ca': {
    dashboard: 'Tableau de bord',
    widget: 'Widget',
    shiftRunner: 'Shift Runner',
    insights: 'Analyses',
    due: 'À échéance',
    expired: 'Expiré',
    upcoming: 'À venir',
    completed: 'Terminé',
    learnMore: 'En savoir plus',
    pleaseSubscribe: 'Veuillez vous abonner',
    // CreateDashboard
    'create-dashboard': 'Créer un tableau de bord',
    name: 'Nom',
    roles: 'Rôles',
    'starting-point': 'Point de départ',
    'name-description':
      'Choisissez un nom pour votre tableau de bord. Les utilisateurs verront ce nom dans le sélecteur.',
    'roles-description':
      'Sélectionnez les rôles pour votre tableau de bord. Les utilisateurs à qui ces rôles sont attribués pourront le voir et le choisir.',
    'starting-point-description':
      'Choisissez un point de départ. Vous pouvez partir d’un tableau de bord QSRSoft, d’un autre tableau de bord que vous avez créé ou d’une page vierge.',
    cancel: 'Annuler',
    back: 'Retour',
    next: 'Suivant',
    preview: 'Aperçu',
    'name-required': 'Le nom est obligatoire',
    'name-exists': 'Un tableau de bord portant ce nom existe déjà',
    'roles-required': 'Les rôles sont obligatoires',
    'blank-canvas': 'Page vierge',
    'qsr-presets': 'Préréglages QSR',
    'your-saved-dashboards': 'Vos tableaux de bord enregistrés',
    // ResetDashboard
    'reset-dashboard': 'Réinitialiser le tableau de bord',
    'reset-description':
      'Choisissez le point de départ vers lequel réinitialiser le tableau de bord sélectionné. Vous pouvez choisir un tableau de bord QSRSoft ou une page vierge. Après avoir choisi un point de départ, cliquez sur Enregistrer pour appliquer les modifications.',
    // Settings
    'widget-settings': 'Paramètres du widget',
    'row-settings': 'Paramètres des rangées',
    'column-settings': 'Paramètres des colonnes',
    close: 'Fermer',
    reset: 'Réinitialiser',
    save: 'Enregistrer',
    // DashboardContainerSettingsMulti
    customizeDashboardContainers: 'Personnaliser les conteneurs du tableau de bord',
    unableToSaveSettings: 'Impossible d’enregistrer les paramètres du tableau de bord.',
    unableToResetSettings: 'Impossible de rétablir les paramètres par défaut du tableau de bord.',
    // no_favorites_card
    noShortcuts: 'Vous n’avez aucun raccourci de dossier ou de fichier.',
    add: 'Ajouter',
    // Shared
    moreInfo: 'Plus de renseignements',
    noData: 'Aucune donnée',
    actual: 'Réel',
    current: 'En cours',
    // BudgetWidget
    budget: 'Budget',
    fiscalPeriod: 'Période financière',
    vsBudget: 'C. budget',
    // FoodWidget
    food: 'Aliments',
    week: 'Semaine',
    // TextSettings
    bulletinBoardSettings: 'Paramètres du babillard',
    addText: 'Ajouter du texte',
    isLink: 'est un lien',
    url: 'URL',
    text: 'Texte',
    // BUSalesRankPopUp
    oneYearComp: 'Comparaison 1 an',
    twoYearComp: 'Comparaison 2 ans',
    // VoiceSmiley
    voice: 'VOICE',
    surveys: 'Sondages',
    numSurveys: 'Nb de sondages',
    voiceInfoText:
      'Les données sont reçues 2 jours après SMG et regroupées selon la date de visite du client. SMG utilise par défaut la date du sondage. En raison de ces différences, il ne faut <strong>pas</strong> s’attendre à ce que les deux sources concordent.',
    // SmileySettings
    metric: 'Indicateur',
    all: 'Tous',
    metrics: 'Indicateurs',
    differentThresholds: 'Les indicateurs sélectionnés ont des seuils différents.',
    orSelectFewer: 'ou sélectionnez moins d’indicateurs.',
    groupedMetrics: 'Voici les indicateurs regroupés :',
    group: 'Groupe',
    happyUpper: 'satisfait - borne supérieure',
    happyLower: 'satisfait - borne inférieure',
    neutralLower: 'neutre - borne inférieure',
    // RMHC / Round Up
    roundUp: 'Arrondi pour la cause',
    helpingHands: 'Helping Hands',
    mtdDollar: 'CMJ $',
    mtdCount: 'Nombre CMJ',
    progressGoal: 'Progression / objectif',
    pctToGoal: '% de l’objectif atteint :',
    goalsHit: 'Objectifs atteints :',
    orgSettingsChanging: 'Modification des paramètres de l’organisation',
    orgSettingsConfirm:
      'Vous êtes sur le point de modifier des paramètres au niveau de l’organisation. Voulez-vous continuer?',
    no: 'Non',
    donationDollar: 'Don $',
    donationCount: 'Nombre de dons',
    goal: 'Objectif',
    numOfDonations: 'Nb de dons',
    donationsDollar: 'Dons $',
    donationsCountGoal: 'Objectif de nombre de dons',
    donationsDollarGoal: 'Objectif de dons $',
    pctOfGoal: '% de l’objectif',
    // Voice row labels
    voiceOverall: 'Global',
    beNice: 'Amabilité',
    beFast: 'Rapidité',
    quality: 'Qualité',
    clean: 'Propreté',
    accuracy: 'Exactitude',
    // VoiceContainer
    customerFeedbackAndDonations: 'Commentaires des clients et dons',
    // BigArch / Incentives
    bigArch: 'Big Arch',
    'hot-honey': 'Hot Honey',
    'snack-wraps': 'Snack Wraps',
    // Shared incentive keys
    'incentive-rank-out-of': 'Classement sur',
    'incentive-restaurants': 'Restaurants',
    'incentive-rank': 'Classement',
    'incentive-rank-compared': 'Classement du restaurant par rapport à l’ensemble de l’unité d’affaires',
    'incentive-units-1k-gc': 'Unités/1 000 GC',
    'incentive-units-1k-rod-gc': 'Unités/1 000 GC ROD',
    // BigArchWidget
    'big-arch-units': 'Unités Big Arch',
    'big-arch-sold-related':
      'Nombre d’articles du menu liés à Big Arch vendus pendant le reste de la journée (ROD) par millier d’unités.',
    'big-arch-menu-items':
      'Les articles du menu associés sont les 25442, 25443 et 25444',
    // HotHoneyWidget
    'hot-honey-units': 'Unités Hot Honey',
    'hot-honey-sold-related':
      'Nombre d’articles du menu liés à Hot Honey vendus pendant le reste de la journée (ROD) par millier d’unités.',
    // SnackWrapsWidget
    'wrap-units': 'Unités Wrap',
    'snack-wraps-message':
      'Les Snack Wraps sont désormais déclarés ici comme des articles individuels',
    'snack-wraps-sold-related':
      'Nombre d’articles du menu liés aux Wraps vendus pendant le reste de la journée (ROD) par millier d’unités.',
    // IncentiveContainer
    leaderboard: 'Classement',
    'mccrispy-strips': 'McCrispy Strips',
    'round-up-pos': 'Arrondi pour la cause PDV/employé',
    '3d-gc-incentive': 'Programme incitatif achalandage 3D',
    'default-incentives': 'Programmes incitatifs par défaut',
    'new-beverage': 'Nouveaux breuvages',
    // BUGrid
    org: 'Organisation',
    orgVs: 'Organisation c.',
    // BusinessUnitContainer
    comp: 'Comparaison',
    sales: 'Ventes',
    service: 'Service',
    labor: 'Main-d’œuvre',
    'digital-app': 'Application mobile',
    'addon-subscribed': 'Module complémentaire BU · Abonné',
    'addon-upgrade': 'Module complémentaire BU · Mise à niveau',
    'addon-upgrade-tooltip':
      'Parlez à votre responsable de l’unité d’affaires de l’ajout de l’Abonnement de l’Unité d’Affaires pour obtenir une visibilité sur les vues de Comparaison de l’unité d’affaires',
    'bu-no-visibility':
      'Vous n’avez pas accès à la vue Comparaison de l’unité d’affaires pour une ou plusieurs des raisons suivantes :',
    'bu-app-backgrounded':
      'Sur mobile, l’application est restée trop longtemps en arrière-plan. Si c’est le cas, veuillez quitter et redémarrer l’application.',
    'bu-no-subscription':
      'Votre unité d’affaires n’est pas abonnée au produit BU Data & Analytics',
    'bu-opted-out':
      'Vous avez « refusé » le partage de données de l’unité d’affaires dans l’administration MyQSRSoft.',
    'bu-contact-leadership':
      'Veuillez communiquer avec la direction de votre unité d’affaires pour toute question sur l’abonnement et les vues de rapports associées.',
    // BUCompTypeSelector
    'comp-calendar': 'Calendrier',
    'comp-trading': 'Exercice commercial',
    'comp-same-store': 'Restaurants comparables',
    'comp-all-store': 'Tous les restaurants',
    // BUSales tooltip
    'bu-financial-info':
      'Le mode Financier s’applique au mois en cours ou aux plages de dates qui dépassent les mois complétés. Il exclut les emplacements ouverts depuis moins de 13 mois complets. Par défaut, le mode Financier utilise la comparaison par jour d’exploitation.',
    'bu-analytic-info':
      'Le mode Analytique s’applique aux mois complétés et aux plages de dates qui comprennent des mois complétés. Il applique une règle de 5 jours : si un emplacement n’a aucune vente pendant 5 jours ou plus (année en cours ou année précédente), il est exclu du calcul. Par défaut, le mode Analytique utilise la comparaison par jour civil.',
    'bu-financial-info-rank':
      'Le mode Financier s’applique au mois en cours ou aux plages de dates qui dépassent les mois complétés. Il exclut les emplacements ouverts depuis moins de 13 mois complets. Par défaut, comparaison par jour d’exploitation.',
    'bu-analytic-info-rank':
      'Le mode Analytique s’applique aux mois complétés et aux plages de dates qui comprennent des mois complétés. Il applique une règle de 5 jours : si un emplacement n’a aucune vente pendant 5 jours ou plus (année en cours ou année précédente), il est exclu du calcul. Par défaut, comparaison par jour civil.',
    // BUSales rows
    'bu-row-sales': 'Ventes',
    'bu-row-gcs': 'GC',
    'bu-row-avg-sales': 'Ventes moyennes',
    'bu-row-avg-check': 'Facture moyenne',
    'bu-row-avg-check-diff': 'Facture moyenne +/-',
    'bu-row-avg-check-diff-pct': 'Facture moyenne +/- %',
    'bu-row-bfast-gcrd': 'GC/R/J déjeuner',
    'bu-row-bfast-gcrd-diff': 'GC/R/J déjeuner +/-',
    'bu-row-bfast-pct-sales': '% des ventes du déjeuner',
    'bu-row-mcdelivery-avg-check': 'Facture moyenne McDelivery',
    'bu-row-mcdelivery-gcrd': 'GC/R/J McDelivery',
    'bu-row-mcdelivery-gcrd-diff': 'GC/R/J McDelivery +/-',
    'bu-row-gma-del-avg-check': 'Facture moyenne livraison GMA',
    'bu-row-gma-del-gcrd-diff': 'GC/R/J livraison GMA +/-',
    'bu-row-3po-avg-check': 'Facture moyenne 3PO',
    'bu-row-3po-gcrd-diff': 'GC/R/J 3PO +/-',
    'bu-row-dt-pct-sales': '% des ventes totales au service au volant',
    'bu-row-dt-gcrd': 'GC/R/J service au volant',
    'bu-row-dt-gcrd-diff': 'GC/R/J service au volant +/-',
    // BUPeaksService format info tooltip
    'bu-peaks-timeslice-label': 'Créneau horaire',
    'bu-peaks-format-info-diff': "Les valeurs par défaut affichent l'écart relatif par rapport à votre BU",
    'bu-peaks-format-info-detail': 'Activez « Afficher les valeurs BU/Org » pour afficher les valeurs brutes de chaque indicateur',
    // BUService rows
    'bu-row-oepe-no-park': 'OEPE sans stationnement',
    'bu-row-oepe-no-park-diff': 'OEPE sans stationnement +/-',
    'bu-row-oepe': 'OEPE',
    'bu-row-oepe-diff': 'OEPE +/-',
    'bu-row-r2p': 'R2P',
    'bu-row-r2p-diff': 'R2P +/-',
    'bu-row-avg-ctp': 'CTP moyen',
    'bu-row-avg-ctp-diff': 'CTP moyen +/-',
    'bu-row-kvs-items-gc': 'Articles KVS / GC',
    'bu-row-kvs-items-gc-diff': 'Articles KVS / GC +/-',
    'bu-row-kvs-time-gc': 'Temps KVS / GC',
    'bu-row-kvs-time-gc-diff': 'Temps KVS / GC +/-',
    'bu-row-dt-pulled-fwd': '% devancés au service au volant',
    'bu-row-dt-pulled-fwd-diff': '% devancés au service au volant +/-',
    'bu-row-healthy-use': 'Utilisation saine',
    'bu-row-healthy-use-diff': 'Utilisation saine +/-',
    // BULabor rows
    'bu-row-crew-labor': '% main-d’œuvre équipiers',
    'bu-row-actual-labor': '% main-d’œuvre réelle',
    'bu-row-avg-rate': 'Taux moyen',
    'bu-row-tpph': 'TPPH',
    'bu-row-total-labor': '% main-d’œuvre totale',
    // BUFood rows
    'bu-row-base-food': '% aliments de base',
    'bu-row-comp-waste': '% pertes produits finis',
    'bu-row-condiments': '% condiments',
    'bu-row-discount': '% rabais',
    'bu-row-emp-meals': '% repas employés',
    'bu-row-fob': '% FOB',
    'bu-row-raw-waste': '% pertes brutes',
    'bu-row-stat-var': '% écart statistique',
    'bu-row-unexplained': '% inexpliqué',
    'bu-row-pnl-food-cost': '% coût des aliments (profits et pertes)',
    'bu-row-pnl-paper-cost': '% coût du papier (profits et pertes)',
    // BUDigitalApp rows
    'bu-row-digital-sales': '% ventes numériques',
    'bu-row-digital-gc': '% GC numérique',
    'bu-row-digital-avg-check': 'Facture moyenne numérique',
    'bu-row-digital-grd': 'G/R/J numérique',
    'bu-row-scanned-offer-sales': 'Ventes offres numérisées',
    'bu-row-scanned-offer-gcs': 'GC offres numérisées',
    'bu-row-scanned-offer-avg-check': 'Facture moyenne offres numérisées',
    'bu-row-scanned-offer-grd': 'G/R/J offres numérisées',
    'bu-row-gma-delivery-sales': 'Ventes livraison GMA',
    'bu-row-gma-delivery-gcs': 'GC livraison GMA',
    'bu-row-gma-delivery-avg-check': 'Facture moyenne livraison GMA',
    'bu-row-gma-delivery-grd': 'G/R/J livraison GMA',
    'bu-row-loyalty-sales': 'Ventes auto-identification fidélité',
    'bu-row-loyalty-gcs': 'GC auto-identification fidélité',
    'bu-row-loyalty-avg-check': 'Facture moyenne auto-identification fidélité',
    'bu-row-loyalty-grd': 'G/R/J auto-identification fidélité',
    'bu-row-mop-offer-sales': 'Ventes MOP avec offre',
    'bu-row-mop-offer-gcs': 'GC MOP avec offre',
    'bu-row-mop-offer-avg-check': 'Facture moyenne MOP avec offre',
    'bu-row-mop-offer-grd': 'G/R/J MOP avec offre',
    'bu-row-mop-no-offer-sales': 'Ventes MOP sans offre',
    'bu-row-mop-no-offer-gcs': 'GC MOP sans offre',
    'bu-row-mop-no-offer-avg-check': 'Facture moyenne MOP sans offre',
    'bu-row-mop-no-offer-grd': 'G/R/J MOP sans offre',
    'bu-row-mop-curb-gcs': '% GC MOP ramassage en bordure',
    'bu-row-mop-fc-gcs': '% GC MOP comptoir',
    'bu-row-mop-table-gcs': '% GC MOP à la table',
    'bu-row-mop-dt-gcs': '% GC MOP service au volant',
    // BUVoice rows
    'bu-row-overall': '% global',
    'bu-row-friendliness': '% amabilité',
    'bu-row-fast': '% rapidité',
    'bu-row-quality': '% qualité',
    'bu-row-cleanliness': '% propreté',
    'bu-row-accuracy': '% exactitude',
    'bu-row-dt-overall': '% global service au volant',
    'bu-row-dt-friendliness': '% amabilité service au volant',
    'bu-row-dt-fast': '% rapidité service au volant',
    'bu-row-dt-quality': '% qualité service au volant',
    'bu-row-dt-cleanliness': '% propreté service au volant',
    'bu-row-dt-accuracy': '% exactitude service au volant',
    'bu-row-fc-overall': '% global comptoir',
    'bu-row-fc-friendliness': '% amabilité comptoir',
    'bu-row-fc-fast': '% rapidité comptoir',
    'bu-row-fc-quality': '% qualité comptoir',
    'bu-row-fc-cleanliness': '% propreté comptoir',
    'bu-row-fc-accuracy': '% exactitude comptoir',
    // BUTurnover rows
    'bu-row-crew-mth-ann-turnover': 'Roulement mens. ann. équipiers',
    'bu-row-crew-3mo-turnover': 'Roulement équipiers sur 3 mois',
    'bu-row-crew-term': 'Cessations équipiers',
    'bu-row-avg-crew-hire': 'Embauches moy. équipiers',
    'bu-row-crew-roster': 'Liste des équipiers',
    'bu-row-crew-ttm-turnover': 'Roulement TTM équipiers',
    'bu-row-crew-ytd-turnover': 'Roulement cumulé annuel équipiers',
    'bu-row-shift-mth-ann-turnover': 'Roulement mens. ann. gérants de quart',
    'bu-row-shift-3mo-turnover': 'Roulement gérants de quart sur 3 mois',
    'bu-row-shift-term': 'Cessations gérants de quart',
    'bu-row-avg-shift-hire': 'Embauches moy. gérants de quart',
    'bu-row-shift-roster': 'Liste des gérants de quart',
    'bu-row-shift-ttm-turnover': 'Roulement TTM gérants de quart',
    'bu-row-shift-ytd-turnover': 'Roulement cumulé annuel gérants de quart',
    // BUDigitalOrderPts rows
    'bu-row-dop-digital-gc': '% GC numérique',
    'bu-row-dop-digital-sales': '% ventes numériques',
    'bu-row-dop-digital-grd': 'G/R/J numérique',
    'bu-row-dop-mop-gcs': '% GC MOP',
    'bu-row-dop-mop-sales': '% ventes MOP',
    'bu-row-dop-mop-gcrd': 'GC/R/J MOP',
    'bu-row-dop-gma-del-gc': '% GC livraison GMA',
    'bu-row-dop-gma-del-sales': '% ventes livraison GMA',
    'bu-row-dop-gma-del-grd': 'G/R/J livraison GMA',
    'bu-row-dop-kiosk-gc': '% GC borne',
    'bu-row-dop-kiosk-sales': '% ventes borne',
    'bu-row-dop-kiosk-grd': 'G/R/J borne',
    'bu-row-dop-delivery-gc': '% GC livraison',
    'bu-row-dop-delivery-sales': '% ventes livraison',
    'bu-row-dop-delivery-grd': 'G/R/J livraison',
    // BUDateRange
    'start-date': 'Date de début',
    'end-date': 'Date de fin',
    // BUSalesRankPopUp
    'bu-sales': 'Ventes de l’unité d’affaires',
    rankings: 'Classements',
    'custom-date-range-bu': 'Plage de dates personnalisée',
    thru: 'Au',
    // BUDigitalApp
    'fo-disclaimer':
      'Les résultats de ventes FO sont affichés après la publication trimestrielle des ventes de McDonald’s.',
    // BUVoice
    'voice-rankings': 'Classements Voice',
    'bu-comp-type-disclaimer':
      'Ce widget n’est offert que pour les types de comparaison Unité d’affaires et Bureau régional.',
    'voice-data-behind':
      'Les données Voice accusent habituellement 2 jours de retard. Veuillez sélectionner une plage de dates antérieure',
    // BUTurnover
    people: 'Ressources humaines',
    'people-metrics-full-months':
      'Les indicateurs RH sont calculés à partir de mois complets.',
    'people-multiple-months':
      'Si plusieurs mois sont sélectionnés, le mois complet le plus récent est utilisé.',
    'people-partial-month':
      'Si un mois passé est partiellement sélectionné, le mois complet est utilisé.',
    'people-detailed-breakdown':
      'Pour une ventilation détaillée, consultez le rapport BU Rank.',
    'people-requires-full-month': 'Les données RH exigent une plage de dates couvrant un mois complet',
    // BUDigitalOrderPts
    'digital-order-pts': 'Points de commande numériques',
    // BUAppTrends
    'bu-loyalty-trend': 'Tendance des membres fidélité actifs sur 90 jours de l’unité d’affaires',
    'bu-loyalty-tooltip':
      'Nombre de clients uniques ayant enregistré au moins un GC par l’application mobile durant la période de 90 jours. Comme un client peut fréquenter plus d’un restaurant d’une même organisation, ce nombre ne peut pas être additionné d’un restaurant à l’autre.',
    // Consulting
    qsrsoftConsultingServices: 'Services-conseils QSRSoft',
    consultingHelpsCapture:
      'Les services-conseils QSRSoft aident à saisir les occasions liées aux flux de trésorerie',
    cashflowOpportunity: 'Occasion liée aux flux de trésorerie',
    total: 'Total',
    laborPotentialCF: 'Flux de trésorerie potentiel - main-d’œuvre',
    fobPotentialCF: 'Flux de trésorerie potentiel - FOB',
    buGCGapPotentialCF: 'Flux de trésorerie potentiel - écart de GC de l’unité d’affaires',
    // File Manager
    resourceLibrary: 'Bibliothèque de ressources',
    // Calendar
    calendar: 'Calendrier',
    all_roles: 'Tous les rôles',
    organization_calendar: 'Calendrier de l’organisation',
    shared: 'Partagé',
    birthdays: 'Anniversaires',
    work_anniversaries: 'Anniversaires d’embauche',
    // ScoreCard
    scorecards: 'Fiches de rendement',
    'please-contact-org-admin':
      'Veuillez communiquer avec l’administrateur de votre organisation pour créer une fiche de rendement.',
    mtd: 'CMJ',
    'last-month': 'Mois dernier',
    ytd: 'CAJ',
    color: 'Couleur',
    'scorecard-setting': 'Paramètres de la fiche de rendement',
    settings: 'Paramètres',
    delete: 'Supprimer',
    'delete-scorecard': 'Supprimer la fiche de rendement',
    'are-you-sure':
      'Voulez-vous vraiment supprimer cette fiche de rendement? Cette action est irréversible.',
    'no-data': 'Aucune donnée',
    'avg-goal': 'Objectif moyen',
    diff: 'Écart',
    // TH Dashboard - Insights
    'did-you-know': 'Le saviez-vous?',
    'employee-requests': 'Demandes des employés',
    waste: 'Pertes',
    'closing-hours': 'Heures de fermeture',
    // WasteInsight template
    'waste-insight-text':
      '{dateText}, vous avez {count} {storeWord} pour lesquels il manque au moins {threshold} {dayWord} de pertes enregistrées',
    'store-singular': 'restaurant',
    'store-plural': 'restaurants',
    'day-singular': 'jour',
    'day-plural': 'jours',
    // ClosingHourInsight template
    'closing-hour-insight-text':
      '{dateText}, vous avez {lobbyCount} salles à manger et {dtCount} services au volant où la dernière transaction précède l’heure de fermeture de {threshold} minutes ou plus',
    // TH Dashboard - Today
    today: 'Aujourd’hui',
    'current-day-sales': 'Ventes du jour',
    'current-day-service': 'Service du jour',
    'current-day-updates-around': 'Les données du jour sont mises à jour vers {time}',
    // TH Dashboard - Snapshot
    snapshot: 'Aperçu instantané',
    'dayparts-sales': 'Ventes par période de la journée',
    'dayparts-service': 'Service par période de la journée',
    'open-11am': 'Ouverture - 11 h',
    '11am-close': '11 h - fermeture',
    'service-times': 'Temps de service',
    // TH CurrentDaySales / SalesWidget rows
    'th-row-net-sales': 'Ventes nettes',
    'th-row-transactions': 'Transactions',
    'th-row-refund-transactions': 'Transactions remboursées',
    'th-row-eat-in-trans': 'Trans sur place',
    'th-row-eat-in-refund-trans': 'Trans remboursées sur place',
    'th-row-take-out-trans': 'Trans pour emporter',
    'th-row-take-out-refund-trans': 'Trans remboursées pour emporter',
    'th-row-drive-thru-trans': 'Trans service au volant',
    'th-row-drive-thru-refund-trans': 'Trans remboursées service au volant',
    'th-row-delivery-trans': 'Trans livraison',
    'th-row-delivery-refund-trans': 'Trans remboursées livraison',
    'th-row-kiosk-trans': 'Trans borne',
    'th-row-kiosk-refund-trans': 'Trans remboursées borne',
    'th-row-mobile-take-out-trans': 'Trans pour emporter mobile',
    'th-row-mobile-take-out-refund-trans': 'Trans remboursées pour emporter mobile',
    'th-row-mobile-drive-thru-trans': 'Trans service au volant mobile',
    'th-row-mobile-drive-thru-refund-trans': 'Trans remboursées service au volant mobile',
    'th-row-refund-sales': 'Ventes remboursées',
    'th-row-avg-check': 'Facture moyenne',
    'th-row-eat-in-net-sales': 'Ventes nettes sur place',
    'th-row-eat-in-refund-sales': 'Ventes remboursées sur place',
    'th-row-eat-in-avg-check': 'Facture moyenne sur place',
    'th-row-take-out-net-sales': 'Ventes nettes pour emporter',
    'th-row-take-out-refund-sales': 'Ventes remboursées pour emporter',
    'th-row-take-out-avg-check': 'Facture moyenne pour emporter',
    'th-row-drive-thru-net-sales': 'Ventes nettes service au volant',
    'th-row-drive-thru-refund-sales': 'Ventes remboursées service au volant',
    'th-row-drive-thru-avg-check': 'Facture moyenne service au volant',
    'th-row-delivery-net-sales': 'Ventes nettes livraison',
    'th-row-delivery-refund-sales': 'Ventes remboursées livraison',
    'th-row-delivery-avg-check': 'Facture moyenne livraison',
    'th-row-kiosk-net-sales': 'Ventes nettes borne',
    'th-row-kiosk-refund-sales': 'Ventes remboursées borne',
    'th-row-kiosk-avg-check': 'Facture moyenne borne',
    'th-row-mobile-take-out-net-sales': 'Ventes nettes pour emporter mobile',
    'th-row-mobile-take-out-refund-sales': 'Ventes remboursées pour emporter mobile',
    'th-row-mobile-take-out-avg-check': 'Facture moyenne pour emporter mobile',
    'th-row-mobile-delivery-net-sales': 'Ventes nettes livraison mobile',
    'th-row-mobile-delivery-refund-sales': 'Ventes remboursées livraison mobile',
    'th-row-mobile-delivery-avg-check': 'Facture moyenne livraison mobile',
    // TH Service rows
    'th-row-greet-time': 'Temps d’accueil',
    'th-row-order-time': 'Temps de commande',
    'th-row-queue-time': 'Temps d’attente en file',
    'th-row-window-time': 'Temps au guichet',
    'th-row-total-time': 'Temps total',
    // TH SalesWidget (Snapshot) rows
    'th-row-manager-void-amt': 'Mnt annulations gérant',
    'th-row-cash-over-short': 'Excédent/manque de caisse',
    'th-row-canceled-item-amt': 'Mnt articles annulés',
    'th-row-canceled-item-cnt': 'Nb articles annulés',
    'th-row-canceled-order-amt': 'Mnt commandes annulées',
    'th-row-canceled-order-cnt': 'Nb commandes annulées',
    'th-row-manager-void-cnt': 'Nb annulations gérant',
    'th-row-overring-amt': 'Mnt surenregistrements',
    // TH Labor rows
    'th-row-hourly-labor-pct': '% main-d’œuvre horaire',
    'th-row-hourly-labor-hours': 'Heures de main-d’œuvre horaire',
    'th-row-management-labor-pct': '% main-d’œuvre gestion',
    'th-row-hourly-labor-dollar': 'Main-d’œuvre horaire $',
    'th-row-salaried-labor-hours': 'Heures de main-d’œuvre salariée',
    'th-row-total-labor-pct': '% main-d’œuvre totale',
    'th-row-proj-labor-guide': 'Guide de main-d’œuvre prévu',
    'th-row-total-labor-hours': 'Heures totales de main-d’œuvre',
    'th-row-training-hours': 'Heures de formation',
    'th-row-labor-cost': 'Coût de la main-d’œuvre',
    'th-row-trans-per-labor-hour': 'Trans / heure de main-d’œuvre',
    'th-row-act-labor-guide-hours': 'Heures guides de main-d’œuvre réelles',
    'th-row-adj-proj-hours': 'Heures prév. ajust. +/-',
    'th-row-avg-hourly-rate': 'Taux horaire moyen',
    // TH Shared headers
    'plus-minus': '+/-',
    // TH Main section titles
    controls: 'Contrôles',
    'shared-links': 'Liens partagés',
    'file-manager': 'Gestionnaire de fichiers',
    'mock-role': 'Rôle simulé',
    forms: 'Formulaires',
    equipment: 'Équipement',
    // Standard main section titles
    'snapshot-month': 'Aperçu du mois',
    // Calendar
    'view-calendar': 'Voir le calendrier',
    'calendar-options': 'Options du calendrier',
    // TH Budget rows
    'th-row-total-labor-dollars': 'Total de la main-d’œuvre en dollars',
    'th-row-food-cost': 'Coût des aliments',
    'th-row-food-cost-pct': '% coût des aliments',
    'th-row-annual-salary': 'Salaire annuel',
    'th-row-crew-dollars': 'Équipiers en dollars',
    'th-row-crew-labor-pct': '% main-d’œuvre équipiers',
    'th-row-manager-labor-pct': '% main-d’œuvre gérants',
    // TH Food rows
    'th-row-adj-theo-food-cost-pct': '% coût théorique des aliments ajusté',
    'th-row-food-var-pct': '% écart aliments',
    'th-row-total-waste-pct': '% pertes totales',
    'th-row-total-cost': 'Coût total',
    'th-row-paper-cost': 'Coût du papier',
    'th-row-other-cost': 'Coût autres',
    'th-row-total-var-cost': 'Coût de l’écart total',
    'th-row-food-var-cost': 'Coût de l’écart aliments',
    'th-row-paper-var-cost': 'Coût de l’écart papier',
    'th-row-other-var-cost': 'Coût de l’écart autres',
    'th-row-total-waste-cost': 'Coût des pertes totales',
    'th-row-total-cost-pct': '% coût total',
    'th-row-paper-cost-pct': '% coût du papier',
    'th-row-other-cost-pct': '% coût autres',
    'th-row-total-var-pct': '% écart total',
    'th-row-paper-var-pct': '% écart papier',
    'th-row-other-var-pct': '% écart autres',
    'th-row-theo-food-cost-pct': '% coût théorique des aliments',
    'th-row-gap-variance-pct': '% écart d’intervalle',
    // TH DayPart Sales rows
    'th-row-daypart-sales': 'Ventes',
    'th-row-daypart-avg-chk': 'Facture moy.',
    'th-row-daypart-tcs': 'TC',
    'th-row-daypart-dt-sales': 'Ventes SV',
    'th-row-daypart-dt-avg-chk': 'Facture moy. SV',
    'th-row-daypart-dt-tcs': 'TC SV',
    'th-row-daypart-lobby-sales': 'Ventes salle à manger',
    'th-row-daypart-lobby-avg-chk': 'Facture moy. salle à manger',
    'th-row-daypart-lobby-tcs': 'TC salle à manger',
    // CompTypeSelector
    'trading': 'Exercice commercial',
    // Security / Insights
    'error-loading-data': 'Erreur de chargement des données',
    'security-events': 'Événements',
    'security-locations': 'Emplacements',
    'security-employees': 'Employés',
    'security-drill-down': 'Analyse de sécurité',
    'top-events': 'Principaux événements',
    'top-locations': 'Principaux emplacements',
    'top-cashiers': 'Principaux caissiers',
    'top-managers': 'Principaux gérants',
    'cashiers': 'Caissiers',
    'managers': 'Gérants',
    // SecurityTable
    'transactions': 'TRANSACTIONS',
    'activity-label': 'Activité',
    'date-header': 'Date',
    'time-header': 'Heure',
    'daypart-header': 'Période de la journée',
    'register-header': 'Caisse',
    'crew-header': 'Équipier',
    'manager-header': 'Gérant',
    'mgr-code-header': 'Code de gérant saisi',
    'details-header': 'Voir le détail',
    'camera-header': 'Caméra',
    'amount-header': 'Montant',
    'remaining-amount-header': 'Montant restant',
    'tender-type-header': 'Mode de paiement',
    'loyalty-id-header': 'ID fidélité',
    'event-type-header': 'Type',
    'activity-type-header': 'Type d’activité',
    'promo-type-header': 'Type de promo',
    'discount-type-header': 'Type de rabais',
    'billable-org-header': 'Organisation facturable',
    'lockout-type-header': 'Type de verrouillage',
    'item-count-header': 'Nombre d’articles',
    'coupon-type-header': 'Type de coupon',
    'overring-amount-header': 'Montant du surenregistrement',
    'reduction-amount-header': 'Montant de la réduction',
    'discount-amount-header': 'Montant du rabais',
    'promo-amount-header': 'Montant de la promo',
    'refund-amount-header': 'Montant du remboursement',
    'data-failed-to-load': 'Le chargement des données a échoué. Veuillez réessayer.',
    'boolean-true': 'Vrai',
    'boolean-false': 'Faux',
    'tender-cash': 'Comptant',
    'tender-cashless': 'Sans comptant',
    'tender-us$_cashless': 'Sans comptant $ US',
    'tender-gift_card': 'Carte-cadeau',
    'tender-no_tender': 'Aucun paiement',
    'tender-billable_sales': 'Ventes facturables',
    'tender-other': 'Autre',
    // Security event token labels
    'cash_refund': 'Remboursement comptant',
    'cashless_refund': 'Remboursement sans comptant',
    'pos_overring': 'Surenregistrement PDV',
    'other_promo': 'Autre promo',
    'total_order_promo': 'Promo totale',
    'total_promo': 'Promo totale',
    'billable_sales': 'Ventes facturables',
    'drawer_open': 'Ouverture de tiroir',
    't_red_before': 'Réduction de transaction avant',
    't_red_after': 'Réduction de transaction après',
    'mobile_discount': 'Rabais mobile',
    'mobile_promo': 'Promo mobile',
    'pos_auto_discount': 'Rabais automatique PDV',
    'other_discount': 'Autre rabais',
    'loyalty_reward_ids': 'Récompense fidélité',
    'employee_meal': 'Repas employé',
    'manager_meal': 'Repas gérant',
    'duplicate_card_swipe': 'Passage de carte en double',
    'coupon': 'Coupon',
    'all_discount': 'Tous les rabais',
    'all_promo': 'Toutes les promos',
    'high_lock_out': 'Verrouillage élevé',
    'delivery_promo': 'Promo livraison',
    'all_events': 'Activités mixtes',
    'event-type-earn': 'Accumulation',
    'event-type-burn': 'Utilisation',
    // SecurityTableSlideUp
    'highlight-info': 'Les rangées surlignées indiquent que le caissier a été modifié dans C&I après le changement de tiroir au PDV lors du décompte du tiroir.',
    // MoreInfo
    'more-info': 'Plus de renseignements',
    'view-insight': 'Voir l’analyse',
    'drawer-open-verbiage': '{cashierName} a eu un tiroir avec {eventQuantity} {eventName} le {date} à {location}',
    'drawer-open-verbiage-burst': '{cashierName} a eu une série de {eventQuantity} {eventName} le {date} à {location}',
    'other-verbiage': '{cashierName} a eu un tiroir avec {eventQuantity} {eventName} totalisant {eventAmount} le {date} à {location}',
    'other-verbiage-burst': '{cashierName} a eu une série de {eventQuantity} {eventName} totalisant {eventAmount} le {date} à {location}',
    'extended-over-eight-hours-drawer-open-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré en moyenne {eventQuantity} {eventName}/8 h de PDV au cours des {numOfDays} derniers jours à {location}',
    'extended-over-eight-hours-other-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré en moyenne {eventAmount} de {eventName}/8 h de PDV au cours des {numOfDays} derniers jours à {location}',
    'extended-less-than-eight-hours-drawer-open-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré {eventQuantity} {eventName} en {lessEightHours} h de PDV au cours des {numOfDays} derniers jours à {location} (moins de 8 h)',
    'extended-less-than-eight-hours-other-verbiage-for-cashier': 'Le caissier {cashierName} a enregistré {eventAmount} de {eventName} en {lessEightHours} h de PDV au cours des {numOfDays} derniers jours à {location}',
    'extended-drawer-open-verbiage-for-manager': 'Le gérant {managerName} a approuvé au total {eventQuantity} {eventName} au cours des {numOfDays} derniers jours à {location}',
    'extended-other-verbiage-for-manager': 'Le gérant {managerName} a approuvé au total {eventAmount} de {eventName} au cours des {numOfDays} derniers jours à {location}',
    'data-failed-to-load-support': 'Le chargement des données a échoué. Veuillez réessayer ou communiquer avec le soutien si le problème persiste.',
    // InsightsContainer
    'all-quiet-here': 'Rien à signaler',
    'product-outage': 'Rupture de produit',
    'business-day-close': 'Fermeture de la journée d’exploitation',
    'open-late-close-early': 'Ouverture tardive / fermeture hâtive',
    'minor-exceptions': 'Exceptions - mineurs',
    'product-default': 'Par défaut',
    'product-product-and-inventory': 'Prod/inv',
    'product-people': 'RH',
    'product-shift': 'Quart',
    'product-security': 'Sécurité',
    'employee-request': 'Demandes des employés',
    'suspicious-activity': 'Activité suspecte',
    'rbd': 'RBD',
    'rbd-completed': 'RBD complétés',
    'rbd-activation': 'Activation RBD',
    'rbd-completed-threshold': 'Seuil de RBD complétés',
    'threshold-hint': 'Alerter lorsque des restaurants dépassent ce nombre de RBD complétés en 30 jours (1-10)',
    'potential-ot': 'Temps supp. potentiel',
    'simplethink': 'SimpleThink',
    '30-day-terms': 'Cessations à 30 jours',
    '90-day-terms': 'Cessations à 90 jours',
    'people-terms': 'Cessations RH',
    'last-thirty-days': '30 derniers jours',
    'trailing-365-days': '365 derniers jours',
    'trailing-thirty-days': '30 derniers jours glissants',
    'yesterday': 'Hier',
    'last-seven-days': '7 derniers jours',
    'modified-punches': 'Poinçons modifiés',
    'store-alerts': 'Alertes du restaurant',
    'product-candi': 'C&I',
    'waste-entry': 'Saisie des pertes',
    'stat-inventory': 'Statistiques d’inventaire',
    // OLCEInsight
    'open-late-message': `<strong>{count}</strong> restaurant pourrait avoir enregistré <strong>{daysThreshold}</strong> ouvertures tardives ou plus au cours des 7 derniers jours. | <strong>{count}</strong> restaurants pourraient avoir enregistré <strong>{daysThreshold}</strong> ouvertures tardives ou plus au cours des 7 derniers jours.`,
    'close-early-message': `<strong>{count}</strong> restaurant pourrait avoir enregistré <strong>{daysThreshold}</strong> fermetures hâtives ou plus au cours des 7 derniers jours. | <strong>{count}</strong> restaurants pourraient avoir enregistré <strong>{daysThreshold}</strong> fermetures hâtives ou plus au cours des 7 derniers jours.`,
    // Shift Runner Scorecard
    'sms-shift-runner-scorecard': 'Fiche de rendement du chef de quart',
    'sms-shift-scorecard': 'Fiche de rendement du quart',
    'sms-no-data': 'Aucune donnée',
    'sms-overall': 'Global',
    'sms-shift-prep': 'Préparation du quart',
    'sms-shift-operational-metrics': 'Métriques d’exploitation du quart - vs objectif',
    'sms-shift-runner': 'Chef de quart',
    'sms-shifts': 'Quarts',
    'sms-score': 'Score',
    'sms-pre-shift-checklist': 'Liste de vérification avant quart',
    'sms-travel-path': 'Parcours',
    'sms-oepe-w-o': 'OEPE sans stationnement',
    'sms-r2p': 'R2P',
    'sms-kvs-time-per-gc': 'Temps KVS par client',
    'sms-kvs-healthy-usage': 'Utilisation saine du KVS',
  },
};
